// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Serif:ital,wght@1,500;1,600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Copilot theme tokens (Phase 1: structural surfaces/text/
   borders/accent/shadow). Dark values below are the original
   literals — the dark theme is unchanged. Light overrides live
   in the [data-copilot-theme="light"] block. Only --cop-* vars
   are themed, so impact is scoped to copilot surfaces.
   ============================================================ */
:root {
  --cop-bg-deepest: hsl(224 28% 8%);
  --cop-bg-deep: hsl(224 28% 11%);
  --cop-bg-deep-alt: hsl(226 24% 11%);
  --cop-bg: hsl(224 28% 13%);
  --cop-bg-15: hsl(224 28% 15%);
  --cop-surface: hsl(224 28% 18%);
  --cop-surface-2: hsl(224 28% 22%);
  --cop-surface-3: hsl(224 28% 26%);
  --cop-surface-4: hsl(224 28% 28%);
  --cop-bg-glass-96: hsl(224 28% 13% / 0.96);
  --cop-bg-glass-88: hsl(224 28% 13% / 0.88);
  --cop-bg-glass-55: hsl(224 28% 13% / 0.55);
  --cop-bg-fade: hsl(224 28% 13% / 0);
  --cop-bg-deep-glass: hsl(224 28% 10% / 0.96);
  --cop-surface-16-96: hsl(224 28% 16% / 0.96);
  --cop-surface-14-94: hsl(224 28% 14% / 0.94);
  --cop-surface-14-80: hsl(224 28% 14% / 0.8);
  --cop-surface-18-80: hsl(224 28% 18% / 0.8);
  --cop-border-navy: hsl(224 18% 32% / 0.7);
  --cop-border-navy-2: hsl(224 18% 24% / 0.6);
  --cop-scrim: hsl(224 28% 6% / 0.55);
  --cop-scrim-strong: hsl(224 28% 4% / 0.86);
  --cop-border-strong: hsl(0 0% 100% / 0.22);
  --cop-border-18: hsl(0 0% 100% / 0.18);
  --cop-border-16: hsl(0 0% 100% / 0.16);
  --cop-border-14: hsl(0 0% 100% / 0.14);
  --cop-border: hsl(0 0% 100% / 0.12);
  --cop-border-10: hsl(0 0% 100% / 0.10);
  --cop-border-08: hsl(0 0% 100% / 0.08);
  --cop-border-06: hsl(0 0% 100% / 0.06);
  --cop-border-05: hsl(0 0% 100% / 0.05);
  --cop-border-04: hsl(0 0% 100% / 0.04);
  --cop-border-03: hsl(0 0% 100% / 0.03);
  --cop-fill-95: hsl(0 0% 100% / 0.95);
  --cop-fill-86: hsl(0 0% 100% / 0.86);
  --cop-fill-82: hsl(0 0% 100% / 0.82);
  --cop-fill-74: hsl(0 0% 100% / 0.74);
  --cop-fill-70: hsl(0 0% 100% / 0.70);
  --cop-fill-65: hsl(0 0% 100% / 0.65);
  --cop-fill-42: hsl(0 0% 100% / 0.42);
  --cop-fill-35: hsl(0 0% 100% / 0.35);
  --cop-fill-32: hsl(0 0% 100% / 0.32);
  --cop-text: #fff;
  --cop-text-bright: hsl(0 0% 100%);
  --cop-text-1: #e7e9ee;
  --cop-text-2: #cbd2e0;
  --cop-text-muted: hsl(218 17% 80%);
  --cop-text-muted-75: hsl(218 17% 75%);
  --cop-text-muted-70: hsl(218 17% 70%);
  --cop-text-muted-65: hsl(218 17% 65%);
  --cop-text-dim: hsl(218 17% 60%);
  --cop-gray-96: hsl(0 0% 96%);
  --cop-gray-95: hsl(0 0% 95%);
  --cop-gray-92: hsl(0 0% 92%);
  --cop-gray-90: hsl(0 0% 90%);
  --cop-gray-75: hsl(0 0% 75%);
  --cop-gray-70: hsl(0 0% 70%);
  --cop-gray-65: hsl(0 0% 65%);
  --cop-gray-60: hsl(0 0% 60%);
  --cop-gray-55: hsl(0 0% 55%);
  --cop-gray-50: hsl(0 0% 50%);
  --cop-accent: hsl(217 91% 53%);
  --cop-accent-hover: hsl(217 91% 60%);
  --cop-accent-bright: hsl(217 91% 75%);
  --cop-accent-deep: hsl(217 91% 45%);
  --cop-accent-alt: hsl(213 88% 64%);
  --cop-accent-tint: #cfe0ff;
  --cop-accent-60-60: hsl(217 91% 60% / 0.6);
  --cop-accent-55: hsl(217 91% 53% / 0.55);
  --cop-accent-42: hsl(217 91% 53% / 0.42);
  --cop-accent-35: hsl(217 91% 53% / 0.35);
  --cop-accent-28: hsl(217 91% 53% / 0.28);
  --cop-accent-20: hsl(217 91% 53% / 0.2);
  --cop-accent-16: hsl(217 91% 53% / 0.16);
  --cop-accent-12: hsl(217 91% 53% / 0.12);
  --cop-accent-deep-35: hsl(217 91% 30% / 0.35);
  /* Text/icon ON a solid accent fill. The accent stays a saturated blue in
     both themes, so this is white in both — it is deliberately NOT overridden
     in the light block (text on a blue button must not flip to dark). */
  --cop-on-accent: #fff;
  --cop-shadow-60: rgba(0, 0, 0, 0.6);
  --cop-shadow-45: hsl(0 0% 0% / 0.45);
  --cop-shadow-40b: hsl(0 0% 0% / 0.4);
  --cop-shadow-40: rgba(0, 0, 0, 0.4);
  --cop-shadow-35: rgba(0, 0, 0, 0.35);
  --cop-shadow-32: rgba(0, 0, 0, 0.32);
  --cop-shadow-28: rgba(0, 0, 0, 0.28);
  --cop-shadow-20: rgba(0, 0, 0, 0.20);
  --cop-shadow-18: rgba(0, 0, 0, 0.18);
}

/* ============================================================
   Light theme. Only redefines --cop-* tokens, so the host
   Webconnect/Tokyo app is untouched. Applied via the
   data-copilot-theme="light" attribute on <html> (set by the
   panel header toggle). Surfaces invert to a cool off-white
   ladder; light text becomes dark; white-alpha borders/overlays
   become dark-alpha; shadows soften.
   Phase 2 (semantic banner hues) is still TODO — error/success/
   warning blocks keep their dark-tuned literals for now.
   ============================================================ */
:root[data-copilot-theme="light"] {
  /* surfaces: page = light gray, cards = white, raised = grayer */
  --cop-bg-deepest: hsl(220 16% 89%);
  --cop-bg-deep: hsl(220 18% 92%);
  --cop-bg-deep-alt: hsl(220 18% 92%);
  --cop-bg: hsl(220 24% 97%);
  --cop-bg-15: hsl(220 22% 96%);
  --cop-surface: hsl(0 0% 100%);
  --cop-surface-2: hsl(220 16% 95%);
  --cop-surface-3: hsl(220 16% 91%);
  --cop-surface-4: hsl(220 16% 88%);
  --cop-bg-glass-96: hsl(220 24% 97% / 0.96);
  --cop-bg-glass-88: hsl(220 24% 97% / 0.88);
  --cop-bg-glass-55: hsl(220 24% 97% / 0.55);
  --cop-bg-fade: hsl(220 24% 97% / 0);
  --cop-bg-deep-glass: hsl(220 18% 92% / 0.96);
  --cop-surface-16-96: hsl(220 20% 96% / 0.96);
  --cop-surface-14-94: hsl(220 20% 95% / 0.94);
  --cop-surface-14-80: hsl(220 20% 95% / 0.8);
  --cop-surface-18-80: hsl(0 0% 100% / 0.8);
  --cop-border-navy: hsl(220 14% 60% / 0.55);
  --cop-border-navy-2: hsl(220 14% 65% / 0.5);
  /* modal scrims stay a dark dim so the dialog pops on light too */
  --cop-scrim: hsl(220 24% 18% / 0.32);
  --cop-scrim-strong: hsl(220 24% 18% / 0.5);
  /* borders: black-alpha instead of white-alpha */
  --cop-border-strong: hsl(220 20% 20% / 0.24);
  --cop-border-18: hsl(220 20% 20% / 0.18);
  --cop-border-16: hsl(220 20% 20% / 0.15);
  --cop-border-14: hsl(220 20% 20% / 0.13);
  --cop-border: hsl(220 20% 20% / 0.12);
  --cop-border-10: hsl(220 20% 20% / 0.10);
  --cop-border-08: hsl(220 20% 20% / 0.09);
  --cop-border-06: hsl(220 20% 20% / 0.07);
  --cop-border-05: hsl(220 20% 20% / 0.06);
  --cop-border-04: hsl(220 20% 20% / 0.05);
  --cop-border-03: hsl(220 20% 20% / 0.04);
  /* fills used as text (color:) — dim DARK text at matching alpha */
  --cop-fill-95: hsl(220 25% 16% / 0.95);
  --cop-fill-86: hsl(220 25% 16% / 0.86);
  --cop-fill-82: hsl(220 25% 16% / 0.82);
  --cop-fill-74: hsl(220 20% 20% / 0.74);
  --cop-fill-70: hsl(220 20% 22% / 0.70);
  --cop-fill-65: hsl(220 18% 26% / 0.68);
  --cop-fill-42: hsl(220 16% 30% / 0.55);
  /* fills used as overlay/border */
  --cop-fill-35: hsl(220 20% 20% / 0.14);
  --cop-fill-32: hsl(220 20% 20% / 0.22);
  /* text: light -> dark */
  --cop-text: hsl(220 26% 14%);
  --cop-text-bright: hsl(220 30% 10%);
  --cop-text-1: hsl(220 22% 18%);
  --cop-text-2: hsl(220 16% 30%);
  --cop-text-muted: hsl(218 14% 36%);
  --cop-text-muted-75: hsl(218 13% 40%);
  --cop-text-muted-70: hsl(218 13% 44%);
  --cop-text-muted-65: hsl(218 12% 48%);
  --cop-text-dim: hsl(218 12% 50%);
  /* gray ladder: light-grays (text/icons on dark) -> dark-grays */
  --cop-gray-96: hsl(0 0% 16%);
  --cop-gray-95: hsl(0 0% 18%);
  --cop-gray-92: hsl(0 0% 22%);
  --cop-gray-90: hsl(0 0% 26%);
  --cop-gray-75: hsl(0 0% 36%);
  --cop-gray-70: hsl(0 0% 40%);
  --cop-gray-65: hsl(0 0% 44%);
  --cop-gray-60: hsl(0 0% 46%);
  --cop-gray-55: hsl(0 0% 50%);
  --cop-gray-50: hsl(0 0% 50%);
  /* accent: darken slightly for contrast against white surfaces */
  --cop-accent: hsl(217 91% 48%);
  --cop-accent-hover: hsl(217 91% 42%);
  --cop-accent-bright: hsl(217 80% 44%);
  --cop-accent-deep: hsl(217 91% 40%);
  --cop-accent-alt: hsl(213 80% 46%);
  --cop-accent-tint: hsl(217 70% 42%);
  /* accent alphas (tinted bg/border) read fine on light; keep hue, same alpha */
  --cop-accent-60-60: hsl(217 91% 48% / 0.5);
  --cop-accent-55: hsl(217 91% 48% / 0.18);
  --cop-accent-42: hsl(217 91% 48% / 0.16);
  --cop-accent-35: hsl(217 91% 48% / 0.14);
  --cop-accent-28: hsl(217 91% 48% / 0.16);
  --cop-accent-20: hsl(217 91% 48% / 0.12);
  --cop-accent-16: hsl(217 91% 48% / 0.10);
  --cop-accent-12: hsl(217 91% 48% / 0.10);
  --cop-accent-deep-35: hsl(217 70% 60% / 0.35);
  /* shadows: soften for light mode */
  --cop-shadow-60: rgba(0, 0, 0, 0.18);
  --cop-shadow-45: hsl(0 0% 0% / 0.14);
  --cop-shadow-40b: hsl(0 0% 0% / 0.12);
  --cop-shadow-40: rgba(0, 0, 0, 0.12);
  --cop-shadow-35: rgba(0, 0, 0, 0.10);
  --cop-shadow-32: rgba(0, 0, 0, 0.10);
  --cop-shadow-28: rgba(0, 0, 0, 0.08);
  --cop-shadow-20: rgba(0, 0, 0, 0.06);
  --cop-shadow-18: rgba(0, 0, 0, 0.05);
}

/* Surrounding chrome for the copilot panel — the floating right-side dock,
 * its draggable header, resize handles, dock mode, idle-fade behaviour, and
 * the start-error toast. The conversation surface (welcome / messages /
 * composer) is rendered by the assistant-ui-driven Thread family in
 * src/copilot/assistant-ui/ using Tailwind utilities; rules that styled those
 * elements previously have been removed.
 *
 * Typography note: IBM Plex Sans + Plex Mono are loaded from Google Fonts.
 * The panel is feature-flagged so the fonts only download when a user opens
 * Copilot for the first time. For Electron offline distribution we'd bundle
 * the woff2 files locally — out of scope for this PR.
 */

.copilot-panel {
  position: fixed;
  top: 80px;
  right: 16px;
  /* Webconnect's .the-topbar (our mount-point ancestor) sets
   * user-select:none on itself, and the property inherits. Without an
   * explicit override here, every chat bubble, action card, and message
   * inside the panel is non-selectable — so the user can't copy code
   * blocks or assistant text. Setting :text breaks the inheritance for
   * the panel body; the header still wins with its own :none rule for
   * the drag handle. */
  user-select: text;
  -webkit-user-select: text;
  /* width is set inline from React (userWidth state) so it survives dock
   * toggles. Default lives in the React component (PANEL_DEFAULT_W). */
  /* Definite height (not just max-height): the floating composer is
   * positioned absolute relative to ThreadPrimitive.Root, and Root takes
   * the remaining vertical space via flex:1/min-h-0 inside this flex
   * column. A definite parent height anchors the flex chain — with only
   * max-height the chain falls back to content-sized, the composer rides
   * the bottom of the growing conversation, and once content exceeds
   * max-height the composer clips out via overflow:hidden. min() caps the
   * panel at either 720px (comfortable on tall monitors) or vh-100,
   * whichever is smaller. */
  height: min(720px, calc(100vh - 100px));
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, var(--cop-surface-14-94) 0%, var(--cop-bg-deep-glass) 100%);
  color: var(--cop-text-1);
  border: 1px solid var(--cop-border-10);
  border-radius: 12px;
  box-shadow:
    0 10px 28px var(--cop-shadow-32),
    0 1px 3px var(--cop-shadow-18),
    inset 0 1px 0 var(--cop-border-04);
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  line-height: 1.45;
  z-index: 10000;
  overflow: hidden;

  backdrop-filter: blur(16px) saturate(140%);
  -webkit-backdrop-filter: blur(16px) saturate(140%);
  transition:
    border-color 140ms,
    box-shadow 140ms;
}

/* Top-edge brand-blue stripe. At rest it's a static hairline. While the
 * controller is busy (.copilot-panel--thinking), it thickens slightly and
 * animates as a left-to-right scan — ambient signal that the agent is
 * working without yanking focus to a modal/spinner. */
.copilot-panel::before {
  content: "";
  position: absolute;
  top: 0;
  left: 18px;
  right: 18px;
  height: 1px;
  background: linear-gradient(90deg,
    transparent 0%,
    var(--cop-accent-55) 20%,
    var(--cop-accent-55) 80%,
    transparent 100%);
  background-size: 100% 100%;
  background-position: 0 0;
  pointer-events: none;
  transition: height 200ms ease;
}
.copilot-panel--thinking::before {
  height: 2px;
  background: linear-gradient(90deg,
    transparent 0%,
    var(--cop-accent-hover) 50%,
    transparent 100%);
  background-size: 200% 100%;
  animation: copilot-scan 1.6s linear infinite;
}
@keyframes copilot-scan {
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
}

/* ----- mini mode -----
 * Collapses the panel to just the header + composer, hiding the conversation
 * thread. Useful when the user wants to keep the panel "on" but reclaim VM
 * viewport real estate. Works in both floating and docked modes — height
 * shrinks to fit the remaining content (header + composer), bottom anchor
 * is released so the panel doesn't try to stretch to the viewport bottom. */
/* Recording in progress: hide the whole panel (chrome included) so only the
   floating pill shows. ChatPanel stays mounted — it portals the pill to
   <body>, outside this hidden subtree — so the panel reappears intact when
   recording stops. */
.copilot-panel--recording {
  display: none !important;
}

.copilot-panel--mini {
  height: auto !important;
  bottom: auto !important;
  max-height: none !important;
}
.copilot-panel--mini .copilot-thread-viewport,
.copilot-panel--mini .copilot-thread-feather,
.copilot-panel--mini .copilot-scroll-pip {
  display: none;
}
/* In mini mode the composer is the panel's sole content surface — switch it
 * out of absolute positioning so it flows naturally below the header, and
 * give it real padding instead of the absolute-mode 12px offsets. */
.copilot-panel--mini .copilot-composer-layer {
  position: static;
  padding: 10px 12px 12px;
  left: auto;
  right: auto;
  bottom: auto;
}
.copilot-panel--mini .copilot-chat-panel {
  min-height: 0;
}

/* ----- dock mode -----
 * Sits flush below the denver toolbar (top measured at runtime by the React
 * component and applied inline) and stretches to the viewport bottom. We
 * have to override \`height\` here because the base .copilot-panel rule sets
 * a min(720px, vh-100) cap to make the floating composer anchor correctly;
 * left at that cap the docked panel would only be 720px tall regardless of
 * the available vertical space. Setting height:auto + bottom:0 lets the
 * top/bottom anchors size the panel. */
.copilot-panel--docked {
  top: 60px;
  right: 0;
  bottom: 0;
  height: auto;
  max-height: calc(100vh - 60px);
  border-radius: 0;
  border-right: 0;
  border-top: 1px solid var(--cop-border-10);
  border-bottom: 0;
  /* dock toggle is animated; transform is suspended (no dx/dy applied in
   * docked mode), so width/right/top transitions land cleanly. */
  transition:
    opacity 260ms cubic-bezier(.2,.7,.2,1) 180ms,
    backdrop-filter 260ms ease 180ms,
    -webkit-backdrop-filter 260ms ease 180ms,
    width 240ms cubic-bezier(.2,.7,.2,1),
    top 240ms cubic-bezier(.2,.7,.2,1),
    right 240ms cubic-bezier(.2,.7,.2,1);
}

/* ----- side-by-side dock: shrink the right section so the VM iframe
 * stops sitting underneath the docked panel. CopilotButton sets
 * data-copilot-docked + --copilot-dock-w on <body> when the dock toggle
 * is on; the value tracks userWidth so dragging the west resize handle
 * pulls the iframe in/out with the panel. margin-right (not width) is
 * deliberate: .the-right-section is flex:1 inside .the-main-row, so
 * margin pushes the flex track inward without fighting flex-grow.
 *
 * The Guacamole canvas inside the iframe needs an explicit resync
 * (resize.js#inject_resize) — CopilotButton dispatches a window resize
 * event whenever this var changes, and resize.js's 400 ms debounce
 * collapses drag bursts to a single VM canvas update. */
body[data-copilot-docked="1"] .the-right-section {
  margin-right: var(--copilot-dock-w, 0px);
  transition: margin-right 240ms cubic-bezier(.2,.7,.2,1);
}

/* While the user is actively dragging a copilot panel resize handle, neuter
 * pointer events on the VM iframe. Without this the Guacamole canvas
 * preempts the parent doc's pointer-capture the moment the cursor crosses
 * into the iframe area (a hair to the left of the west handle in docked
 * mode), and the drag locks up after a single pixel. Scoped to the drag
 * only — CopilotButton sets data-copilot-resizing on pointerdown and
 * clears it on pointerup. */
body[data-copilot-resizing="1"] .webconnect-frame {
  pointer-events: none;
}

/* webpack-dev-server v4+ injects a full-viewport iframe
 * (#webpack-dev-server-client-overlay) at z-index 2147483647 that stays
 * in the DOM after first showing a compile warning, with no error UI
 * inside but pointer-events:auto. It silently eats clicks on anything
 * portaled to <body> — including this panel's overflow menu, which has
 * no stacking-context shelter once outside .copilot-panel. Dev-only:
 * the iframe doesn't exist in production builds, so this rule is a
 * no-op in prod. Verified via document.elementsFromPoint at the menu
 * coords returning the overlay iframe instead of the menu button. */
#webpack-dev-server-client-overlay {
  pointer-events: none !important;
}

/* Kill width/margin transitions during an active drag — otherwise the
 * panel and iframe both lerp 240ms behind the pointer and the drag feels
 * laggy. The transitions are what we want on the dock TOGGLE itself
 * (animated slide-in/out), just not while the user is dragging. */
body[data-copilot-resizing="1"] .copilot-panel,
body[data-copilot-resizing="1"] .the-right-section {
  transition: none !important;
}

/* ----- header -----
 * One row: identity → optional pinned tag + status dot → slot picker
 * → primary action icons (workflows, new conversation, overflow, close).
 * Theme/dock/minimize/compact are stashed in the overflow menu so the
 * primary chrome stays minimal. */
.copilot-panel-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: linear-gradient(180deg, var(--cop-surface-18-80) 0%, var(--cop-surface-14-80) 100%);
  border-bottom: 1px solid var(--cop-border-navy-2);
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  min-height: 44px;
}
.copilot-panel--docked .copilot-panel-header {
  cursor: default;
}

.copilot-panel-title {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.005em;
  color: var(--cop-text);
  min-width: 0;
  flex: 0 1 auto;
}

/* Sparkle chip: brand-tinted disc with the lucide Sparkles icon. */
.copilot-panel-title-glyph {
  display: inline-grid;
  place-items: center;
  width: 26px;
  height: 26px;
  border-radius: 999px;
  background:
    radial-gradient(circle at 30% 28%,
      hsl(217 91% 60% / 0.95) 0%,
      hsl(217 91% 45% / 0.85) 55%,
      hsl(217 91% 38% / 0.85) 100%);
  box-shadow:
    0 0 0 1px hsl(217 91% 72% / 0.35),
    0 1px 6px hsl(217 91% 30% / 0.45),
    inset 0 1px 0 hsl(217 91% 80% / 0.35);
  color: #fff;
  flex-shrink: 0;
}
.copilot-panel-title-glyph-icon {
  width: 14px;
  height: 14px;
  stroke-width: 2.25;
}

.copilot-panel-title-text {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

/* Status dot — small, lives next to the title; replaces the bigger
 * "Connected" pulse strip from the old two-row header. */
.copilot-panel-pulse-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: hsl(140 60% 52%);
  box-shadow: 0 0 0 0 hsl(140 60% 50% / 0.6);
  animation: copilot-pulse 2s infinite;
  flex-shrink: 0;
  margin-left: 2px;
}
@keyframes copilot-pulse {
  0%   { box-shadow: 0 0 0 0 hsl(140 60% 50% / 0.5); }
  70%  { box-shadow: 0 0 0 8px hsl(140 60% 50% / 0); }
  100% { box-shadow: 0 0 0 0 hsl(140 60% 50% / 0); }
}

/* Profile slot picker — single-row pill, native chevron kept so it
 * reads as a dropdown. Auto-pushes right via margin-left so it sits
 * between the title block and the action icons. */
.copilot-panel-slot {
  background: var(--cop-surface);
  color: var(--cop-text);
  border: 1px solid var(--cop-border-navy);
  border-radius: 6px;
  padding: 4px 6px 4px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  line-height: 1;
  margin-left: auto;
  transition: border-color 120ms ease, background-color 120ms ease;
}
.copilot-panel-slot:hover:not(:disabled) {
  background: var(--cop-surface-2);
  border-color: var(--cop-accent-42);
}
.copilot-panel-slot:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* When the slot picker is absent (single-slot grants), push the
 * controls to the right edge instead. */
.copilot-panel-controls {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
}
.copilot-panel-slot ~ .copilot-panel-controls {
  margin-left: 0;
}

.copilot-panel-btn {
  background: transparent;
  color: var(--cop-text-2);
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 5px;
  font-size: 12px;
  cursor: pointer;
  line-height: 0;
  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}

.copilot-panel-btn:hover:not(:disabled) {
  background: var(--cop-surface-2);
  color: var(--cop-text);
}

.copilot-panel-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.copilot-panel-btn--icon {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
}

.copilot-panel-btn--close:hover:not(:disabled) {
  background: hsl(0 60% 50% / 0.18);
  color: hsl(0 0% 100%);
}

.copilot-panel-icon {
  width: 15px;
  height: 15px;
  stroke-width: 2;
}

/* Overflow ⋯ menu. Anchored under the trigger; absolute so it stacks
 * over the conversation. */
.copilot-panel-overflow {
  position: relative;
  display: inline-block;
}
/* Portaled to <body>, anchored via inline top/right computed from the
 * trigger button's getBoundingClientRect. Fixed positioning escapes the
 * panel's overflow:hidden + transform (which would clip an in-place
 * absolute/fixed dropdown), so the menu is visible even when the panel
 * is shrunk to mini mode. */
.copilot-panel-overflow-menu {
  position: fixed;
  min-width: 200px;
  padding: 6px;
  background: var(--cop-surface);
  border: 1px solid var(--cop-border-navy-2);
  border-radius: 10px;
  box-shadow:
    0 12px 32px hsl(220 30% 4% / 0.45),
    0 2px 6px hsl(220 30% 4% / 0.35);
  z-index: 10010;  /* sits above the panel itself (z-index: 10000) */
  display: flex;
  flex-direction: column;
  gap: 2px;
  cursor: default;
  /* Override the header's drag cursor so menu items feel clickable. */
}
.copilot-panel-overflow-item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 7px 10px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--cop-text);
  font-size: 12.5px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background-color 100ms ease;
}
.copilot-panel-overflow-item:hover {
  background: var(--cop-surface-2);
}
.copilot-panel-overflow-item[aria-pressed="true"] {
  color: var(--cop-accent-alt);
}
.copilot-panel-overflow-item .copilot-panel-icon {
  opacity: 0.85;
}

/* ----- in-panel confirm modal -----
 * Used for destructive header actions (e.g. profile-slot switch which
 * clears the conversation). Scoped inside .copilot-panel so it doesn't
 * cover the rest of Webconnect, and the backdrop has its own pointer
 * surface so clicking outside the dialog dismisses it. Click on the
 * dialog body itself stops propagation in JS so the backdrop dismiss
 * doesn't fire when the user clicks the modal contents. */
.copilot-modal-backdrop {
  position: absolute;
  inset: 0;
  background: var(--cop-scrim);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  /* Don't leak outside the rounded panel corners. */
  border-radius: inherit;
}

/* Fullscreen variant — used when the modal is rendered outside the Copilot
 * panel (e.g. the repin chooser that fires from the TopBar button). The
 * default backdrop is positioned absolute to overlay just the panel; this
 * variant pins to the viewport instead so the modal isn't clipped by the
 * topbar's bounds. Sits above Denver's chrome (TopBar z-index is ~10). */
.copilot-modal-backdrop--fullscreen {
  position: fixed;
  z-index: 1000;
}
.copilot-modal {
  width: min(320px, calc(100% - 32px));
  background: var(--cop-bg);
  border: 1px solid var(--cop-border);
  border-radius: 10px;
  box-shadow:
    0 12px 32px var(--cop-shadow-40),
    inset 0 1px 0 var(--cop-border-05);
  padding: 16px;
  color: var(--cop-text-1);
  /* The modal is mounted alongside .copilot-root (not inside it), so the
   * inherited white-space:nowrap from the surrounding aux-buttons menu
   * still applies. Reset it here so paragraph text wraps inside the
   * 320px-wide dialog. text-align is reset for the same reason. */
  white-space: normal;
  text-align: left;
}
.copilot-modal-title {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.copilot-modal-body {
  margin: 0 0 14px;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--cop-text-muted-75);
}
.copilot-modal-body strong {
  color: var(--cop-text);
  font-weight: 600;
}
.copilot-modal-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.copilot-modal-btn {
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  line-height: 1.2;
  /* Opt out of the chat panel's break-anywhere policy (set on .copilot-root
   * for pathological URLs / hex tokens). Without these, short labels like
   * "Run" can be wrapped letter-by-letter when the button is a shrinkable
   * flex item next to a content-heavy sibling. */
  white-space: nowrap;
  overflow-wrap: normal;
  flex-shrink: 0;
}
.copilot-modal-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.copilot-modal-btn--ghost {
  background: transparent;
  color: var(--cop-text-2);
  border-color: var(--cop-border-navy);
}
.copilot-modal-btn--ghost:hover:not(:disabled) {
  background: var(--cop-surface-2);
  color: var(--cop-text);
}
.copilot-modal-btn--primary {
  background: var(--cop-accent);
  color: var(--cop-on-accent);
}
.copilot-modal-btn--primary:hover:not(:disabled) {
  background: var(--cop-accent-hover);
}
.copilot-modal-btn--danger {
  background: transparent;
  color: hsl(0 70% 75%);
  border-color: hsl(0 40% 35%);
}
.copilot-modal-btn--danger:hover {
  background: hsl(0 40% 18%);
  color: hsl(0 75% 82%);
}

/* ----- resize handles ----- */
.copilot-resize {
  position: absolute;
  z-index: 1;
  touch-action: none;
}
/* West/East edges are vertical strips along the full panel height. */
.copilot-resize--w,
.copilot-resize--e {
  top: 0;
  bottom: 0;
  width: 6px;
  cursor: ew-resize;
}
.copilot-resize--w { left: 0; }
.copilot-resize--e { right: 0; }

/* South edge is a horizontal strip along the bottom. Stops short of the
 * left/right handles so corner-grabs prefer the width handles (which feel
 * more natural at a corner). */
.copilot-resize--s {
  left: 6px;
  right: 6px;
  bottom: 0;
  height: 6px;
  cursor: ns-resize;
}

.copilot-resize::before {
  content: "";
  position: absolute;
  border-radius: 2px;
  background: var(--cop-border-strong);
  opacity: 0;
  transition: opacity 140ms;
}
/* Vertical edges: 2x36 grip centred vertically. */
.copilot-resize--w::before,
.copilot-resize--e::before {
  top: 50%;
  width: 2px;
  height: 36px;
  transform: translateY(-50%);
}
.copilot-resize--w::before { left: 1px; }
.copilot-resize--e::before { right: 1px; }
/* South edge: 36x2 grip centred horizontally. */
.copilot-resize--s::before {
  left: 50%;
  bottom: 1px;
  width: 36px;
  height: 2px;
  transform: translateX(-50%);
}
.copilot-resize:hover::before { opacity: 0.7; }

/* Conversation surface wrapper — flex container that fills the panel. */
.copilot-chat-panel {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  position: relative;
}

/* Defeat inherited typography rules from the surrounding menu. CopilotButton
 * mounts the panel inside \`<ul#the-menu-items class="aux-buttons">\`, which
 * sets \`white-space: nowrap\` (to keep toolbar items on one line) and
 * \`text-align: right\` (to right-align the toolbar). Both cascade into the
 * panel content — nowrap turns paragraphs into single-line strips and
 * text-align:right pushes message text + JSON dumps to the right edge of
 * each bubble. Resetting at the panel root is enough; block descendants
 * inherit these unless they opt in explicitly. overflow-wrap lets
 * pathological strings (long URLs, hex tokens) break inside bubbles
 * instead of blowing them out. */
.copilot-root {
  white-space: normal;
  text-align: left;
  overflow-wrap: anywhere;
  /* Composer publishes its current height here via ResizeObserver. The
   * thread viewport consumes it as padding-bottom so the last message
   * never hides under the floating composer. */
  --copilot-composer-h: 72px;
}

/* Thread viewport reserves bottom space for the floating composer AND any
 * stacked strips above it: plan-progress (--copilot-plan-h), Guide-mode
 * permission card (--copilot-permission-h), and Guide-step advance chip
 * (--copilot-guide-advance-h). Each var resolves to 0px when its component
 * is not mounted, so the padding stays tight in the common case. */
.copilot-thread-viewport {
  padding-bottom: calc(
    var(--copilot-composer-h)
    + var(--copilot-plan-h, 0px)
    + var(--copilot-permission-h, 0px)
    + var(--copilot-guide-advance-h, 0px)
    + 48px);
}

/* Thin custom scrollbars inside the panel — the OS default (~14-16px on
 * Windows) is too wide for a 400px-wide chat surface. Firefox uses
 * scrollbar-width/scrollbar-color on the scrollable itself; WebKit/Blink
 * uses ::-webkit-scrollbar pseudos which we scope to descendants so any
 * scrollable inside the panel (thread viewport, composer textarea, action
 * card JSON dumps) gets the same treatment without per-element rules. */
.copilot-thread-viewport,
.copilot-composer-wrap textarea,
.copilot-action__details {
  scrollbar-width: thin;
  scrollbar-color: var(--cop-border-strong) transparent;
}
.copilot-root ::-webkit-scrollbar { width: 6px; height: 6px; }
.copilot-root ::-webkit-scrollbar-track { background: transparent; }
.copilot-root ::-webkit-scrollbar-thumb {
  background: var(--cop-border-strong);
  border-radius: 3px;
}
.copilot-root ::-webkit-scrollbar-thumb:hover {
  background: var(--cop-fill-35);
}

/* Feather gradient that fades the last bit of the thread under the composer
 * instead of clipping it abruptly. Positioned over the viewport bottom; its
 * height tracks the composer height so the fade always covers the reserved
 * padding area. */
.copilot-thread-feather {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(
    var(--copilot-composer-h)
    + var(--copilot-plan-h, 0px)
    + var(--copilot-permission-h, 0px)
    + var(--copilot-guide-advance-h, 0px)
    + 56px);
  background: linear-gradient(180deg,
    var(--cop-bg-fade) 0%,
    var(--cop-bg-glass-55) 35%,
    var(--cop-bg-glass-88) 65%,
    var(--cop-bg-glass-96) 100%);
  pointer-events: none;
}

/* Floating composer layer — sibling of the scroll viewport, never scrolls. */
.copilot-composer-layer {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Composer wrap holds the input + the keyboard-hint footer. */
.copilot-composer-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Scroll-to-bottom pip floats just above the composer, right-aligned. */
.copilot-scroll-pip {
  position: absolute;
  right: 4px;
  bottom: calc(100% + 6px);
}

/* Keyboard hint strip below the composer. */
.copilot-composer-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
  font-size: 10.5px;
  color: var(--cop-text-dim);
  letter-spacing: 0.04em;
}
.copilot-composer-hint kbd {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 10px;
  background: var(--cop-border-06);
  border: 1px solid var(--cop-border-10);
  border-bottom-width: 2px;
  border-radius: 4px;
  padding: 0 5px;
  color: var(--cop-text-muted-75);
}
.copilot-composer-hint-sep {
  width: 1px;
  height: 10px;
  background: var(--cop-border-10);
}

/* ----- Welcome / empty-state surface -----
 * Shown when the thread has no messages yet. Centered hero (sparkle disc +
 * heading + subtitle), three suggestion chips, then an optional
 * "Recent workflows" rail. All sizes scale modestly; the rail can be
 * absent (loading / none yet), so the hero stays self-sufficient.
 *
 * Tokens are read from --cop-* + the shadcn vars on .copilot-root so the
 * light theme switches automatically. */
.copilot-welcome {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 20px;
  padding: 28px 20px 16px;
  max-width: 440px;
  width: 100%;
  margin: 0 auto;
}

.copilot-welcome-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}

.copilot-welcome-glyph {
  display: inline-grid;
  place-items: center;
  width: 46px;
  height: 46px;
  border-radius: 999px;
  background:
    radial-gradient(circle at 30% 28%,
      hsl(213 88% 70%) 0%,
      hsl(217 91% 55%) 55%,
      hsl(217 91% 42%) 100%);
  color: #fff;
  box-shadow:
    0 0 0 1px hsl(217 91% 72% / 0.35),
    0 6px 16px hsl(217 91% 28% / 0.45),
    inset 0 1px 0 hsl(213 88% 90% / 0.45);
  position: relative;
}
.copilot-welcome-glyph::after {
  /* subtle pulse halo */
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: inherit;
  box-shadow: 0 0 0 0 hsl(217 91% 60% / 0.45);
  animation: copilot-welcome-halo 3.2s ease-out infinite;
  pointer-events: none;
}
@keyframes copilot-welcome-halo {
  0%   { box-shadow: 0 0 0 0 hsl(217 91% 60% / 0.45); }
  70%  { box-shadow: 0 0 0 12px hsl(217 91% 60% / 0); }
  100% { box-shadow: 0 0 0 0 hsl(217 91% 60% / 0); }
}
.copilot-welcome-glyph-icon {
  width: 22px;
  height: 22px;
  stroke-width: 2;
}

.copilot-welcome-title {
  margin: 4px 0 0;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.005em;
  color: var(--cop-text);
}

.copilot-welcome-subtitle {
  margin: 0;
  max-width: 36ch;
  font-size: 13px;
  line-height: 1.5;
  color: var(--cop-text-muted-70);
}
.copilot-welcome-subtitle em {
  font-style: italic;
  color: var(--cop-text);
}

.copilot-welcome-suggestions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 6px;
}
.copilot-welcome-chip {
  display: block;
  width: 100%;
  padding: 11px 14px;
  background: var(--cop-surface);
  color: var(--cop-text);
  border: 1px solid var(--cop-border-navy);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, transform 120ms ease;
}
.copilot-welcome-chip:hover {
  background: var(--cop-surface-2);
  border-color: var(--cop-accent-42);
}
.copilot-welcome-chip:active {
  transform: translateY(1px);
}
.copilot-welcome-chip:focus-visible {
  outline: 2px solid var(--cop-accent-42);
  outline-offset: 2px;
}

/* Recent workflows rail */
.copilot-welcome-recent {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
}
.copilot-welcome-recent-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4px;
}
.copilot-welcome-recent-title {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--cop-text-muted-70);
}
.copilot-welcome-recent-link {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: transparent;
  border: 0;
  padding: 2px 4px;
  font-size: 11.5px;
  font-weight: 500;
  letter-spacing: 0.01em;
  color: var(--cop-text-muted-70);
  cursor: pointer;
  border-radius: 4px;
}
.copilot-welcome-recent-link:hover {
  color: var(--cop-accent-alt);
}
.copilot-welcome-recent-link-icon {
  width: 13px;
  height: 13px;
  stroke-width: 2.25;
}
.copilot-welcome-recent-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.copilot-welcome-recent-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 9px 10px 9px 11px;
  background: var(--cop-surface);
  border: 1px solid var(--cop-border-navy);
  border-radius: 8px;
  transition: background-color 120ms ease, border-color 120ms ease;
}
.copilot-welcome-recent-row:hover {
  background: var(--cop-surface-2);
  border-color: var(--cop-accent-42);
}
.copilot-welcome-recent-row-icon {
  display: inline-grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: var(--cop-accent-16);
  color: var(--cop-accent-alt);
}
.copilot-welcome-recent-row-icon-svg {
  width: 13px;
  height: 13px;
  stroke-width: 2;
}
.copilot-welcome-recent-row-name {
  font-size: 13px;
  font-weight: 500;
  color: var(--cop-text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.copilot-welcome-recent-run {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  background: transparent;
  color: var(--cop-text-2);
  border: 1px solid var(--cop-border-navy);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}
.copilot-welcome-recent-run:hover:not(:disabled) {
  background: var(--cop-accent-16);
  color: var(--cop-accent-alt);
  border-color: var(--cop-accent-42);
}
.copilot-welcome-recent-run:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.copilot-welcome-recent-run-icon {
  width: 11px;
  height: 11px;
  stroke-width: 2.5;
  fill: currentColor;
}

/* Empty state: no workflows yet. A single inviting CTA that opens the
   workflows library (where recording a new workflow lives), shown in
   place of the recent-workflows list. */
.copilot-welcome-create {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 6px;
  width: 100%;
  padding: 11px 14px;
  background: var(--cop-accent-16);
  color: var(--cop-accent-alt);
  border: 1px dashed var(--cop-accent-42);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;
}
.copilot-welcome-create:hover {
  background: var(--cop-accent-20);
  border-color: var(--cop-accent);
}
.copilot-welcome-create:focus-visible {
  outline: 2px solid var(--cop-accent-42);
  outline-offset: 2px;
}
.copilot-welcome-create-icon {
  width: 15px;
  height: 15px;
  stroke-width: 2.5;
}

/* ----- Thinking bubble -----
 * Equalizer-bar animation. Five vertical brand-blue bars pulse with staggered
 * delays so the wave reads as continuous motion rather than a synchronized
 * flash. The bubble itself fades + rises in on mount so it doesn't pop into
 * existence abruptly when controller.busy flips. */
.copilot-thinking {
  animation: copilot-thinking-in 220ms ease-out;
}
@keyframes copilot-thinking-in {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}
.copilot-thinking-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.copilot-thinking-bars {
  display: flex;
  align-items: center;
  gap: 3px;
  height: 18px;
  width: 36px;
}
.copilot-thinking-bars span {
  display: block;
  width: 3px;
  border-radius: 2px;
  background: linear-gradient(180deg, var(--cop-accent-hover), var(--cop-accent-deep));
  transform-origin: center;
  animation: copilot-eq 1.05s ease-in-out infinite;
}
.copilot-thinking-bars span:nth-child(1) { animation-delay: 0.00s; }
.copilot-thinking-bars span:nth-child(2) { animation-delay: 0.12s; }
.copilot-thinking-bars span:nth-child(3) { animation-delay: 0.24s; }
.copilot-thinking-bars span:nth-child(4) { animation-delay: 0.36s; }
.copilot-thinking-bars span:nth-child(5) { animation-delay: 0.48s; }
@keyframes copilot-eq {
  0%, 100% { height: 25%; opacity: 0.4; }
  50%      { height: 100%; opacity: 1; }
}
.copilot-thinking-label {
  font-family: "IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 10px;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--cop-text-dim);
}

/* ----- ActionCard accent bar -----
 * Brand-blue rail along the left edge marks every tool call as a Copilot
 * action. State (running / done / error / denied / pending) is conveyed by
 * the status icon and the right/top/bottom border colour, which the state
 * badge ring class sets. The bar is a pseudo-element so it doesn't fight
 * Tailwind's border utilities. */
.copilot-action {
  position: relative;
  padding-left: 10px;
}
.copilot-action::before {
  content: "";
  position: absolute;
  left: 0;
  top: -1px;
  bottom: -1px;
  width: 2px;
  background: var(--cop-accent);
  border-radius: 2px 0 0 2px;
}
/* Denied actions get a dimmer rail so the card visually retreats. */
.copilot-action--denied::before { opacity: 0.4; }

/* ----- Safety confirm accent bar — same treatment, scoped via role. */
[role="alertdialog"][aria-label="Confirm action"] {
  position: relative;
  padding-left: 12px;
}
[role="alertdialog"][aria-label="Confirm action"]::before {
  content: "";
  position: absolute;
  left: 0;
  top: -1px;
  bottom: -1px;
  width: 2px;
  background: var(--cop-accent-alt);
  border-radius: 2px 0 0 2px;
}

/* ----- Screenshot thumbnail in assistant bubble -----
 * The image the model saw on this turn, rendered at the top of its bubble.
 * Button reset so the click target stays semantic but visually borderless.
 * Slight inset from the bubble's padded edges, brand-blue hairline frame,
 * and a hover lift that hints at the click-to-zoom affordance. */
.copilot-msg-shot {
  display: block;
  width: 100%;
  margin: 0 0 8px;
  padding: 0;
  background: var(--cop-bg-deepest);
  border: 1px solid var(--cop-accent-28);
  border-radius: 6px;
  overflow: hidden;
  cursor: zoom-in;
  line-height: 0;
  transition: border-color 140ms, box-shadow 140ms;
}
.copilot-msg-shot:hover {
  border-color: var(--cop-accent-55);
  box-shadow: 0 2px 10px var(--cop-accent-deep-35);
}
.copilot-msg-shot:focus-visible {
  outline: 2px solid var(--cop-accent-hover);
  outline-offset: 2px;
}
.copilot-msg-shot img {
  display: block;
  width: 100%;
  height: auto;
  max-height: 220px;
  object-fit: cover;
  object-position: top left;
}

/* ----- Lightbox for full-size screenshot inspection -----
 * Fixed full-viewport overlay above the panel; click backdrop or press
 * Escape to close. The image stops propagation so clicking the photo
 * itself doesn't dismiss. */
.copilot-lightbox {
  position: fixed;
  inset: 0;
  z-index: 10002;
  display: grid;
  place-items: center;
  padding: 32px;
  background: var(--cop-scrim-strong);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  animation: copilot-lightbox-in 160ms ease-out;
  cursor: zoom-out;
}
@keyframes copilot-lightbox-in {
  from { opacity: 0; }
  to   { opacity: 1; }
}
.copilot-lightbox img {
  max-width: 100%;
  max-height: 100%;
  border: 1px solid var(--cop-border-14);
  border-radius: 4px;
  box-shadow: 0 24px 60px var(--cop-shadow-60);
  cursor: default;
}
.copilot-lightbox__close {
  position: absolute;
  top: 16px;
  right: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--cop-border-08);
  color: var(--cop-text);
  border: 1px solid var(--cop-border-18);
  border-radius: 50%;
  cursor: pointer;
  transition: background 140ms, border-color 140ms;
}
.copilot-lightbox__close:hover {
  background: var(--cop-border-16);
  border-color: var(--cop-fill-32);
}

/* ----- Reset .the-topbar list bleed -----
 * The copilot panel is mounted inside \`#the-menu-items.list-horizontal
 * .aux-buttons\` inside \`.the-topbar\`, so style.css's toolbar rules cascade
 * into every <ul>/<li> in the assistant's markdown body:
 *   .the-topbar ul {
 *     display: inline-block; overflow: hidden;
 *     text-wrap-mode: nowrap; white-space-collapse: collapse;
 *   }
 *   .the-topbar .list-horizontal li { display: inline-flex; }
 * Result: LLM bullet lists render as inline-flex pills with nowrap text
 * inside an inline-block parent — long lines bleed past the bubble cap
 * and short labels wrap letter-by-letter into a vertical column. Force
 * the lists back to a plain block layout. \`!important\` is justified
 * here because the toxic rules use 2-class selectors that match or beat
 * anything reasonable I can write inside the panel without spelling out
 * the topbar selectors, and the intent is a hard reset at the markdown
 * boundary regardless of where the panel mounts in future. */
.copilot-msg-markdown ul,
.copilot-msg-markdown ol,
.copilot-msg-text ul,
.copilot-msg-text ol {
  display: block !important;
  margin: 0.25rem 0 !important;
  padding-left: 1.25rem !important;
  overflow: visible !important;
  white-space: normal !important;
  list-style-position: outside !important;
}
.copilot-msg-markdown ul,
.copilot-msg-text ul {
  list-style-type: disc !important;
}
.copilot-msg-markdown ol,
.copilot-msg-text ol {
  list-style-type: decimal !important;
}
.copilot-msg-markdown li,
.copilot-msg-text li {
  display: list-item !important;
  margin: 0 0 0.125rem !important;
  padding: 0 !important;
  line-height: 1.45 !important;
  white-space: normal !important;
}

/* ----- Markdown body wrap-out -----
 * .copilot-root sets overflow-wrap:anywhere at the root, but the markdown
 * lib renders content through nested structures (lists, definition-like
 * blocks, inline <strong>/<em>) where the property doesn't propagate as
 * reliably — long LLM lines without breakable whitespace then escape the
 * 85% bubble cap and crash into the panel right edge. Re-apply wrap +
 * min-width:0 + max-width:100% to every descendant of the markdown body
 * so each block clamps itself to the bubble. <pre> opts back out so code
 * blocks stay scrollable horizontally (handled by tw-overflow-x-auto in
 * MarkdownText.jsx). */
.copilot-msg-text,
.copilot-msg-markdown {
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 0;
  max-width: 100%;
}
.copilot-msg-text *,
.copilot-msg-markdown * {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.copilot-msg-text pre,
.copilot-msg-markdown pre,
.copilot-msg-text pre *,
.copilot-msg-markdown pre * {
  white-space: pre;
  word-break: normal;
  overflow-wrap: normal;
}

/* ----- Compact display mode -----
 * Toggled from the panel header. Hides the per-turn screenshot thumbnail
 * and the action cards, leaving only the model's prose. Safety-confirm
 * prompts ([role="alertdialog"]) stay visible because they require user
 * interaction; the user toggled compact for noise reduction, not to
 * disable safety. */
.copilot-panel--compact .copilot-msg-shot,
.copilot-panel--compact .copilot-action {
  display: none !important;
}

/* Rare full-page error if controller.start() fails during construction. */
.copilot-start-error {
  position: fixed;
  top: 80px;
  right: 16px;
  background: #dc2626;
  /* Hardcoded, not themed: the background is a fixed #dc2626, while --cop-text
   * flips to near-black in the light theme — dark-on-red is unreadable. */
  color: #fff;
  /* The right side reserves room for the dismiss button, which is positioned
   * over the padding. It has to be part of this shorthand rather than a
   * padding-right of its own — a later shorthand would silently reset it. */
  padding: 8px 30px 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  z-index: 10001;
  box-shadow: 0 8px 20px var(--cop-shadow-35);
}

/* Dismiss control. Both toasts also time themselves out (CopilotButton's
 * ERROR_TOAST_MS / SETUP_TOAST_MS), but neither used to clear at all, so this
 * is the immediate way out — it sits over the toast's right padding rather
 * than in flow, so it doesn't reflow the message or the link beside it. */
.copilot-start-error__dismiss {
  position: absolute;
  top: 4px;
  right: 6px;
  padding: 0 4px;
  border: 0;
  background: none;
  color: #fff;
  font-size: 15px;
  line-height: 1.2;
  cursor: pointer;
  opacity: 0.8;
}

.copilot-start-error__dismiss:hover,
.copilot-start-error__dismiss:focus-visible {
  opacity: 1;
}

/* "Set it up" link in the setup-required toast. White on #dc2626 is ~4.9:1,
 * which passes AA for body text. Underlined because colour alone is not a
 * sufficient affordance on an already-coloured surface (and fails WCAG
 * 1.4.1) — the link matches the toast text, so nothing else distinguishes it. */
.copilot-start-error a {
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.copilot-start-error a:hover,
.copilot-start-error a:focus-visible {
  text-decoration-thickness: 2px;
}

/* Plan-progress strip — lives inside .copilot-composer-layer ABOVE the
 * Composer, so it pairs visually with the input. Auto-collapses to a single
 * line once \`current_step\` reaches N/N; manual toggle in either direction
 * via the header chevron / collapsed-bar click. */
.copilot-plan-progress {
  flex-shrink: 0;
  padding: 8px 12px 10px;
  border: 1px solid var(--cop-border-10);
  border-radius: 12px;
  background: var(--cop-bg-15);
  box-shadow: 0 4px 12px var(--cop-shadow-20);
  font-size: 12px;
  line-height: 1.35;
  max-height: 28vh;
  overflow-y: auto;
}
.copilot-plan-progress__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  font-weight: 600;
  color: var(--cop-fill-82);
  letter-spacing: 0.01em;
}
.copilot-plan-progress__header-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.copilot-plan-progress__toggle {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--cop-fill-70);
  cursor: pointer;
}
.copilot-plan-progress__toggle:hover {
  background: var(--cop-border-08);
  color: var(--cop-fill-95);
}
.copilot-plan-progress__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.copilot-plan-progress__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 2px 0;
  color: var(--cop-fill-74);
}
.copilot-plan-progress__item--done {
  color: var(--cop-fill-42);
  text-decoration: line-through;
}
.copilot-plan-progress__item--active {
  color: var(--cop-fill-95);
  font-weight: 500;
}
.copilot-plan-progress__text {
  min-width: 0;
  overflow-wrap: anywhere;
}

/* Collapsed mode: outer flex row hosting an "expand" button (the left
 * portion of the bar) and a dismiss button. The outer is no longer a
 * <button> so the dismiss <button> can be a sibling instead of an
 * invalid nested-button. */
.copilot-plan-progress--collapsed {
  display: flex;
  align-items: stretch;
  gap: 0;
  width: 100%;
  padding: 0;
  max-height: none;
  font-size: 12px;
}
.copilot-plan-progress__expand {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 8px 8px 8px 12px;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
}
.copilot-plan-progress__expand:hover {
  background: var(--cop-border-04);
}
.copilot-plan-progress__expand:focus-visible {
  outline: 2px solid var(--cop-fill-35);
  outline-offset: -2px;
}
.copilot-plan-progress__summary {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--cop-fill-86);
}

/* Dismiss (X) button — sibling of expand in collapsed mode, sibling of
 * the chevron toggle inside the header in expanded mode. */
.copilot-plan-progress__header-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.copilot-plan-progress__dismiss {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--cop-fill-65);
  cursor: pointer;
}
.copilot-plan-progress__dismiss:hover {
  background: var(--cop-border-10);
  color: var(--cop-fill-95);
}
.copilot-plan-progress__dismiss:focus-visible {
  outline: 2px solid var(--cop-fill-35);
  outline-offset: 1px;
}
.copilot-plan-progress--collapsed .copilot-plan-progress__dismiss {
  margin: 6px 10px 6px 0;
}

/* Done tint — applied while collapsed so the receipt reads as success. */
.copilot-plan-progress--done {
  border-color: hsl(152 60% 40% / 0.35);
  background: hsl(152 30% 12%);
}
.copilot-plan-progress--done .copilot-plan-progress__expand:hover {
  background: hsl(152 30% 14%);
}
.copilot-plan-progress--done .copilot-plan-progress__summary {
  color: hsl(152 65% 75%);
}
.copilot-plan-progress--done .copilot-plan-progress__dismiss {
  color: hsl(152 50% 70%);
}

/* ----- Permission card (Tier 1.c § 4.4) -----
 * Inline confirmation surface rendered above the composer layer while
 * controller.pendingPermissionCard is non-null. Brand-blue accent so the
 * card reads as an active prompt; sticky checkbox is intentionally per-card
 * (its state lives in component-local React state) — the persistent
 * "remembered" flag only flips when Allow is chosen WITH the checkbox
 * ticked. */
.copilot-permission-card {
  margin: 8px 12px;
  padding: 12px 14px;
  border: 1px solid var(--cop-accent-42);
  border-radius: 10px;
  background: var(--cop-surface-16-96);
  color: var(--cop-text-1);
  box-shadow: 0 4px 14px var(--cop-shadow-28);
  animation: copilot-thinking-in 220ms ease-out;
}
.copilot-permission-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
  color: var(--cop-accent-bright);
}
.copilot-permission-card__body {
  font-size: 12.5px;
  color: var(--cop-text-muted);
  margin-bottom: 10px;
}
.copilot-permission-card__body em {
  font-style: italic;
  color: var(--cop-text-1);
}
.copilot-permission-card__sticky {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  color: var(--cop-text-muted-70);
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.copilot-permission-card__sticky input {
  margin: 0;
  cursor: pointer;
}
.copilot-permission-card__buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.copilot-permission-card__btn {
  appearance: none;
  font: inherit;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid var(--cop-border-14);
  background: var(--cop-surface-2);
  color: var(--cop-text-1);
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}
.copilot-permission-card__btn:hover {
  background: var(--cop-surface-3);
}
.copilot-permission-card__btn--primary {
  background: var(--cop-accent);
  border-color: var(--cop-accent);
  color: var(--cop-on-accent);
}
.copilot-permission-card__btn--primary:hover {
  background: var(--cop-accent-hover);
  border-color: var(--cop-accent-hover);
}

/* ----- Guide-step advance chip (Tier 1.c § 4.5) -----
 * Renders above the composer layer while controller.guideStepPending is
 * true. Mirrors PermissionCard's brand-blue/dark-theme palette so the two
 * surfaces feel like one family. */
.copilot-guide-advance {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin: 8px 12px;
  padding: 8px 14px;
  border: 1px solid var(--cop-accent-42);
  border-radius: 10px;
  background: var(--cop-surface-16-96);
  box-shadow: 0 4px 14px var(--cop-shadow-28);
  animation: copilot-thinking-in 220ms ease-out;
}
.copilot-guide-advance__btn {
  appearance: none;
  font: inherit;
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid var(--cop-border-14);
  background: var(--cop-surface-2);
  color: var(--cop-text-1);
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
  /* Equal-width buttons so the two-button row reads as a tidy centered
   * pair instead of two random-width pills. */
  flex: 1 1;
  max-width: 220px;
  text-align: center;
}
.copilot-guide-advance__btn:hover {
  background: var(--cop-surface-3);
}
.copilot-guide-advance__btn--primary {
  background: var(--cop-accent);
  border-color: var(--cop-accent);
  color: var(--cop-on-accent);
}
.copilot-guide-advance__btn--primary:hover {
  background: var(--cop-accent-hover);
  border-color: var(--cop-accent-hover);
}

/* ─── System breadcrumb pills ───
 * Lifted from kyoto-client-side-only-prototype-v2.js § cua-perm-breadcrumb.
 * "✓" leading glyph → granted (green); "✕" → denied (purple). Renders as a
 * compact inline pill rather than a full muted card so the eye doesn't
 * mistake it for a model reply. */
.copilot-breadcrumb {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  margin: 4px 0;
  border-radius: 999px;
  font-size: 11px;
  line-height: 1.4;
  font-weight: 500;
}
.copilot-breadcrumb--granted {
  background: rgba(74, 222, 128, 0.10);
  border: 1px solid rgba(74, 222, 128, 0.28);
  color: #6ee7a4;
}
.copilot-breadcrumb--denied {
  background: rgba(168, 85, 247, 0.10);
  border: 1px solid rgba(168, 85, 247, 0.28);
  color: #c4b5fd;
}

/* ─── Copy-to-clipboard button on fenced code blocks ───
 * Solid-color button (not Tailwind opacity modifier — the theme's HSL
 * vars don't carry an <alpha-value> placeholder, so /xx modifiers are
 * dropped). High contrast against the muted code-block background so
 * the icon is readable without hover. */
.copilot-codeblock-copy {
  position: absolute;
  top: 6px;
  right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid var(--cop-border-14);
  border-radius: 6px;
  background: var(--cop-surface-2);
  color: var(--cop-text-1);
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease, border-color 120ms ease;
}
.copilot-codeblock-copy:hover {
  background: var(--cop-surface-4);
  border-color: var(--cop-border-strong);
}
.copilot-codeblock-copy:focus-visible {
  outline: 2px solid var(--cop-accent-60-60);
  outline-offset: 1px;
}

/* Belt-and-suspenders: force readable text inside fenced code blocks
 * regardless of what the assistant-ui markdown primitive applies. */
.copilot-msg-markdown pre,
.copilot-msg-markdown pre code {
  color: var(--cop-text-1);
  background: var(--cop-bg-deep-alt);
}

/* ===========================================================================
 * Workflow surface (B sub-project)
 *
 * Layered on top of the generic .copilot-modal* classes. The library and
 * param modal use --wide variants because they list rows / inputs that
 * don't fit the default 320px dialog width.
 * ========================================================================= */

.copilot-workflow-library,
.copilot-workflow-modal {
  /* Wider than the default .copilot-modal — listings and forms need room. */
  width: min(520px, calc(100% - 32px));
  max-height: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.copilot-workflow-search {
  width: 100%;
  box-sizing: border-box;
  background: var(--cop-surface);
  border: 1px solid var(--cop-border-10);
  border-radius: 6px;
  padding: 7px 10px;
  color: var(--cop-text-1);
  font-size: 12.5px;
}
.copilot-workflow-search:focus-visible {
  outline: 2px solid var(--cop-accent-60-60);
  outline-offset: 1px;
}

.copilot-workflow-list {
  flex: 1 1 auto;
  min-height: 80px;
  max-height: 50vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 2px;
}

.copilot-workflow-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  background: var(--cop-surface);
  border: 1px solid var(--cop-border-08);
  border-radius: 8px;
  padding: 10px 12px;
}
.copilot-workflow-row-info {
  flex: 1 1 auto;
  min-width: 0;
}
.copilot-workflow-row-actions {
  flex: 0 0 auto;
  display: flex;
  gap: 6px;
  align-items: center;
}
.copilot-workflow-row-name {
  font-weight: 600;
  font-size: 13px;
  color: var(--cop-text);
  overflow: hidden;
  text-overflow: ellipsis;
}
.copilot-workflow-row-summary {
  margin-top: 2px;
  font-size: 12px;
  color: var(--cop-text-muted);
  line-height: 1.4;
}
.copilot-workflow-row-meta {
  margin-top: 4px;
  font-size: 11.5px;
  color: var(--cop-text-dim);
}

/* Params block inside the run modal */
.copilot-workflow-params {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 50vh;
  overflow-y: auto;
}
.copilot-workflow-param {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.copilot-workflow-param-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--cop-text-2);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.copilot-workflow-param input {
  background: var(--cop-surface);
  border: 1px solid var(--cop-border-10);
  border-radius: 6px;
  padding: 7px 10px;
  color: var(--cop-text-1);
  font-size: 12.5px;
}
.copilot-workflow-param input[data-error="true"] {
  border-color: hsl(0 70% 55%);
}
.copilot-workflow-param input:focus-visible {
  outline: 2px solid var(--cop-accent-60-60);
  outline-offset: 1px;
}
.copilot-workflow-param-desc {
  font-size: 11.5px;
  color: var(--cop-text-muted-65);
}
.copilot-workflow-param-error {
  font-size: 11.5px;
  color: hsl(0 70% 70%);
}

/* Inline marker shown above the chat thread while a workflow run is active */
.copilot-workflow-run-marker {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 12px 8px;
  padding: 8px 10px;
  background: var(--cop-accent-12);
  border: 1px solid var(--cop-accent-35);
  border-radius: 6px;
  font-size: 12px;
  color: var(--cop-accent-tint);
  line-height: 1.4;
}

.copilot-workflow-run-marker__text {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}

.copilot-workflow-run-marker__close {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: -2px -2px 0 0;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--cop-accent-tint);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 120ms, background 120ms;
}

.copilot-workflow-run-marker__close:hover {
  opacity: 1;
  background: var(--cop-accent-20);
}

/* ============================================================
 * D.3 Workflow recording UI (Tasks 11–21)
 * Pill, settings popover, drafts list, library Record CTA,
 * wizard modal (compile / review / saved stages).
 * ============================================================ */

@keyframes cua-pulse {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.4; }
}

@keyframes cua-spin {
  to { transform: rotate(360deg); }
}

/* --- Floating recording pill (portaled to <body>) --- */

.cua-pill {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2147483000;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 11px 18px 11px 20px;
  background: var(--cop-bg);
  border: 1px solid var(--cop-border);
  border-radius: 999px;
  box-shadow: 0 10px 30px var(--cop-shadow-45);
  color: var(--cop-gray-96);
  font: 500 16px/1 "IBM Plex Sans", system-ui, sans-serif;
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
          user-select: none;
}

.cua-pill:active { cursor: grabbing; }

.cua-pill-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: hsl(0 75% 55%);
  animation: cua-pulse 1.4s ease-in-out infinite;
}

.cua-pill-time {
  min-width: 4ch;
  font-variant-numeric: tabular-nums;
}

.cua-pill-no-mic {
  color: var(--cop-gray-65);
  font-size: 12px;
}

.cua-pill-bars {
  display: inline-flex;
  align-items: flex-end;
  gap: 2px;
  height: 18px;
}

.cua-pill-bar {
  width: 3px;
  background: hsl(140 60% 55%);
  border-radius: 1px;
  transition: height 80ms linear;
}

.cua-pill-stop {
  background: hsl(0 75% 55%);
  color: var(--cop-text-bright);
  border: none;
  border-radius: 999px;
  padding: 9px 20px;
  font: 600 15px/1 inherit;
  cursor: pointer;
}

.cua-pill-stop:hover { filter: brightness(1.1); }

.cua-pill-warning {
  border-color: hsl(40 90% 55%);
  background: hsl(35 30% 15%);
  color: hsl(45 95% 80%);
}

.cua-pill-warning .cua-pill-dot { background: hsl(40 90% 55%); }

/* --- Library header: Record CTA + Settings gear --- */

/* Record-a-new-workflow card. Replaces the old single-line "Record a new
 * workflow" button — promotes the recording flow to a self-explanatory
 * panel with a narration opt-out the user sees BEFORE the browser prompts
 * for mic permission, and a prominent red CTA. */
.cua-record-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px 16px;
  margin-bottom: 16px;
  background: hsl(0 60% 12% / 0.18);
  border: 1px solid hsl(0 70% 50% / 0.32);
  border-radius: 12px;
}

.cua-record-card-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--cop-text);
}

.cua-record-card-blurb {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--cop-text-muted-75);
}

.cua-record-card-narrate {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 9px 11px;
  background: var(--cop-surface-2);
  border: 1px solid var(--cop-border-navy);
  border-radius: 8px;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--cop-text);
  cursor: pointer;
  transition: border-color 120ms ease, background-color 120ms ease;
}
.cua-record-card-narrate:hover {
  border-color: var(--cop-accent-42);
}
.cua-record-card-narrate input[type="checkbox"] {
  /* native checkbox kept — accent-color tints the V check without breaking
   * keyboard semantics. Sized up so it visually balances the text block. */
  width: 16px;
  height: 16px;
  margin: 2px 0 0;
  accent-color: hsl(140 65% 45%);
  cursor: pointer;
  flex-shrink: 0;
}
.cua-record-card-narrate strong {
  font-weight: 600;
}

.cua-record-card-muted {
  color: var(--cop-text-muted-70);
}

.cua-record-card-hint {
  margin: 0;
  font-size: 12px;
  color: var(--cop-text-muted-70);
}
.cua-record-card-hint strong {
  color: var(--cop-text-muted-75);
  font-weight: 600;
}

.cua-record-card-actions {
  display: flex;
  align-items: stretch;
  gap: 8px;
  margin-top: 2px;
}

.cua-record-card-start {
  flex: 1 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 11px 16px;
  background: hsl(0 72% 52%);
  color: #fff;
  border: 0;
  border-radius: 8px;
  font: 600 14px/1 "IBM Plex Sans", system-ui, sans-serif;
  letter-spacing: 0.01em;
  cursor: pointer;
  box-shadow:
    0 1px 0 hsl(0 72% 62% / 0.35) inset,
    0 6px 14px hsl(0 72% 25% / 0.35);
  transition: filter 120ms ease, transform 80ms ease;
}
.cua-record-card-start:hover:not(:disabled) {
  filter: brightness(1.06);
}
.cua-record-card-start:active:not(:disabled) {
  transform: translateY(1px);
}
.cua-record-card-start:disabled {
  background: var(--cop-surface-2);
  color: var(--cop-text-muted-70);
  cursor: not-allowed;
  box-shadow: none;
}
/* Slightly larger dot inside the big CTA so it reads at the button's scale. */
.cua-record-card-start .cua-library-rec-dot {
  width: 9px;
  height: 9px;
  background: #fff;
  box-shadow: 0 0 0 3px hsl(0 0% 100% / 0.18);
}

.cua-library-rec-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: hsl(0 75% 55%);
  flex-shrink: 0;
}

.cua-library-rec-warn {
  background: hsl(40 30% 14%);
  color: hsl(45 90% 78%);
  border: 1px solid hsl(40 60% 30%);
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  margin-top: 4px;
}

/* --- Settings popover (gear) --- */

.cua-settings {
  position: relative;
}

.cua-settings-trigger {
  background: var(--cop-border-06);
  color: var(--cop-gray-90);
  border: 1px solid var(--cop-border);
  border-radius: 6px;
  width: 36px;
  height: 36px;
  font-size: 16px;
  cursor: pointer;
}

.cua-settings-trigger:hover { background: var(--cop-border-10); }

.cua-settings-popover {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: var(--cop-bg);
  border: 1px solid var(--cop-border);
  border-radius: 6px;
  padding: 10px;
  z-index: 10;
  min-width: 200px;
  box-shadow: 0 6px 20px var(--cop-shadow-40b);
}

.cua-settings-h {
  font-size: 12px;
  color: var(--cop-gray-70);
  margin-bottom: 6px;
}

.cua-settings-opt {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  cursor: pointer;
  font-size: 13px;
  color: var(--cop-gray-92);
}

/* --- Drafts list --- */

.cua-drafts {
  margin-bottom: 14px;
}

.cua-drafts-header {
  font-size: 13px;
  color: var(--cop-gray-75);
  margin-bottom: 6px;
}

.cua-drafts-banner {
  background: hsl(40 30% 14%);
  color: hsl(45 90% 78%);
  border: 1px solid hsl(40 60% 30%);
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  margin-bottom: 8px;
}

.cua-drafts-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cua-drafts-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  background: var(--cop-border-03);
  border: 1px solid var(--cop-border-08);
  border-radius: 6px;
}

.cua-drafts-row-thumb {
  flex: 0 0 auto;
  width: 48px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
  background: var(--cop-border-05);
}
.cua-drafts-row-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.cua-drafts-row-thumb-empty {
  width: 100%;
  height: 100%;
  background: var(--cop-border-04);
}

.cua-drafts-row-main { flex: 1 1 auto; min-width: 0; }

.cua-drafts-row-name { font-weight: 600; color: var(--cop-gray-95); font-size: 13px; }
.cua-drafts-row-meta { font-size: 12px; color: var(--cop-gray-65); display: block; margin-top: 2px; }

.cua-drafts-status {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 11px;
  background: var(--cop-border-08);
  color: var(--cop-gray-90);
}
.cua-drafts-status-compiled { background: hsl(140 50% 25%); color: hsl(140 60% 85%); }
.cua-drafts-status-compile_failed { background: hsl(0 50% 25%); color: hsl(0 60% 85%); }

.cua-drafts-row-actions { display: flex; gap: 6px; }

.cua-drafts-resume, .cua-drafts-discard {
  background: var(--cop-border-06);
  color: var(--cop-gray-92);
  border: 1px solid var(--cop-border);
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
}

.cua-drafts-discard { color: hsl(0 70% 75%); }
.cua-drafts-resume:hover { background: var(--cop-border); }
.cua-drafts-discard:hover { background: hsl(0 50% 20%); }

/* --- Wizard modal (inside the panel) --- */

.cua-wizard-modal {
  position: absolute;
  inset: 0;
  background: var(--cop-bg-deep);
  border: 1px solid var(--cop-border);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  z-index: 20;
  overflow: hidden;
}

.cua-wizard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--cop-border-08);
}

.cua-wizard-title {
  font: 600 15px/1 "IBM Plex Sans", system-ui, sans-serif;
  color: var(--cop-gray-96);
}

.cua-wizard-close {
  background: transparent;
  color: var(--cop-gray-70);
  border: none;
  font-size: 22px;
  cursor: pointer;
  line-height: 1;
}

.cua-wizard-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  color: var(--cop-gray-92);
  font-size: 13px;
}

/* --- Compile stage --- */

.cua-compile-stage { display: flex; flex-direction: column; gap: 14px; }

.cua-compile-autostop-banner {
  background: hsl(40 30% 14%);
  color: hsl(45 90% 78%);
  border: 1px solid hsl(40 60% 30%);
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
}

.cua-compile-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--cop-border);
  border-top-color: var(--cop-accent-hover);
  border-radius: 50%;
  margin: 8px auto;
  animation: cua-spin 0.9s linear infinite;
}

.cua-compile-phases {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
}

.cua-compile-phases li.pending { color: var(--cop-gray-50); }
.cua-compile-phases li.active  { color: var(--cop-accent-bright); font-weight: 600; }
.cua-compile-phases li.done    { color: hsl(140 50% 75%); }

.cua-compile-error {
  background: hsl(0 50% 18%);
  color: hsl(0 70% 88%);
  border: 1px solid hsl(0 60% 35%);
  border-radius: 6px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cua-compile-retry {
  align-self: flex-start;
  background: hsl(0 60% 35%);
  color: var(--cop-text-bright);
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

/* --- Review form --- */

.cua-review-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cua-review-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cua-review-section-title {
  font: 600 12px/1 "IBM Plex Sans", system-ui, sans-serif;
  color: var(--cop-gray-70);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cua-review-field { display: flex; flex-direction: column; gap: 4px; }
.cua-review-field label { font-size: 12px; color: var(--cop-gray-70); }
.cua-review-field input,
.cua-review-field textarea,
.cua-review-notes,
.cua-review-step-intent,
.cua-review-step-uses,
.cua-review-param-name,
.cua-review-param-desc,
.cua-review-prereq {
  background: var(--cop-border-05);
  color: var(--cop-gray-95);
  border: 1px solid var(--cop-border);
  border-radius: 4px;
  padding: 6px 8px;
  font: 400 13px/1.4 "IBM Plex Sans", system-ui, sans-serif;
  width: 100%;
  box-sizing: border-box;
}

.cua-review-field-error {
  color: hsl(0 70% 75%);
  font-size: 12px;
  margin-top: 2px;
}

.cua-review-row {
  display: flex;
  gap: 6px;
  align-items: center;
}

.cua-review-row-remove {
  background: transparent;
  color: var(--cop-gray-60);
  border: 1px solid var(--cop-border);
  border-radius: 4px;
  width: 24px;
  height: 24px;
  font-size: 12px;
  cursor: pointer;
}

.cua-review-row-add {
  align-self: flex-start;
  background: var(--cop-border-05);
  color: var(--cop-accent-bright);
  border: 1px dashed var(--cop-border-18);
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
}

.cua-review-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid var(--cop-border-08);
}

.cua-review-meta {
  font-size: 12px;
  color: var(--cop-gray-65);
}

.cua-review-actions {
  display: flex;
  gap: 8px;
}

/* Review/saved footer buttons use the shared .copilot-modal-btn classes
   (including --danger) for sizing parity with the rest of the panel — the
   former .cua-btn-primary/.cua-btn-danger rules were removed. */

/* --- Saved stage --- */

.cua-saved-stage {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 16px;
  text-align: center;
}

.cua-check {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: hsl(140 50% 25%);
  color: hsl(140 60% 85%);
  display: grid;
  place-items: center;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
}

.cua-saved-name {
  font: 600 16px/1.2 "IBM Plex Sans", system-ui, sans-serif;
  color: var(--cop-gray-96);
}

.cua-saved-sub {
  font-size: 12px;
  color: var(--cop-gray-65);
}

.cua-saved-hint {
  font-size: 12px;
  color: var(--cop-gray-55);
  font-style: italic;
  margin: 8px 0;
}

.cua-saved-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

/* ============================================================
   Captured stage — "review your take" before compiling.
   ============================================================ */
.cua-captured-stage {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 4px 2px;
}

.cua-captured-filmstrip {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: thin;
}

.cua-captured-frame {
  margin: 0;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  position: relative;
}

.cua-captured-frame img {
  width: 135px;
  height: 83px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid var(--cop-border);
  background: var(--cop-gray-12);
  display: block;
  cursor: zoom-in;
}

/* Per-frame multi-select toggle — a custom circular check, hidden until hover
   or when on. */
.cua-captured-frame-sel {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 1.5px solid #fff;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: transparent;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.12s ease, background 0.12s ease;
  display: grid;
  place-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}
.cua-captured-frame:hover .cua-captured-frame-sel,
.cua-captured-frame-sel.is-on,
.cua-captured-frame-sel:focus-visible { opacity: 1; }
.cua-captured-frame-sel.is-on {
  background: var(--cop-accent, hsl(220 90% 66%));
  border-color: var(--cop-accent, hsl(220 90% 66%));
  color: #fff;
}
.cua-captured-frame--selected img {
  outline: 2px solid var(--cop-accent, hsl(220 90% 66%));
  outline-offset: -2px;
}

/* Per-frame quick-delete ✕ (top-right) — instant single-frame delete. */
.cua-captured-frame-del {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.12s ease, background 0.12s ease;
  display: grid;
  place-items: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}
.cua-captured-frame:hover .cua-captured-frame-del,
.cua-captured-frame-del:focus-visible { opacity: 1; }
.cua-captured-frame-del:hover { background: hsl(0 70% 45%); }

.cua-captured-selbar {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: var(--cop-gray-96);
}
.cua-captured-selbar .copilot-modal-btn { margin-left: auto; }

/* Zoom preview — a modest centred enlargement, not a full-page lightbox. */
.cua-captured-zoom {
  position: fixed;
  inset: 0;
  z-index: 10060;            /* above the sheet (10050) */
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  cursor: zoom-out;
}
.cua-captured-zoom img {
  max-width: min(1100px, 90vw);
  max-height: 88vh;
  border-radius: 8px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.5);
  cursor: default;
}

.cua-captured-transcribe {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}
.cua-captured-transcribe-link {
  background: none;
  border: none;
  padding: 0;
  color: var(--cop-accent, hsl(220 90% 66%));
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
}
.cua-captured-transcribe-link:disabled {
  color: var(--cop-gray-55);
  cursor: default;
  text-decoration: none;
}
.cua-captured-optional-hint {
  font-size: 11px;
  color: var(--cop-gray-55);
}

.cua-captured-frame figcaption {
  font-size: 10px;
  color: var(--cop-gray-55);
  font-variant-numeric: tabular-nums;
}

.cua-captured-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 13px;
  color: var(--cop-gray-96);
}

.cua-captured-sep { color: var(--cop-gray-55); }

.cua-captured-narration { min-height: 24px; }

.cua-captured-hint {
  font-size: 12px;
  color: var(--cop-gray-65);
  font-style: italic;
}

.cua-captured-transcript {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid var(--cop-border);
  border-radius: 8px;
  padding: 10px 12px;
  background: var(--cop-gray-12);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cua-captured-transcript-empty {
  font-size: 12px;
  color: var(--cop-gray-55);
  font-style: italic;
}

.cua-captured-transcript-line {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 1.4;
}

.cua-captured-transcript-t {
  flex-shrink: 0;
  color: var(--cop-gray-55);
  font-variant-numeric: tabular-nums;
}

.cua-captured-transcript-input {
  flex: 1 1 auto;
  min-width: 0;
  background: var(--cop-gray-16, var(--cop-gray-12));
  border: 1px solid var(--cop-border);
  border-radius: 5px;
  color: var(--cop-gray-96);
  font-size: 12px;
  padding: 3px 7px;
}
.cua-captured-transcript-input:focus {
  outline: none;
  border-color: var(--cop-accent, hsl(220 90% 66%));
}

.cua-captured-transcript-del {
  flex: 0 0 auto;
  background: none;
  border: none;
  color: var(--cop-gray-55);
  font-size: 11px;
  cursor: pointer;
  padding: 2px 4px;
}
.cua-captured-transcript-del:hover { color: hsl(0 70% 60%); }

.cua-captured-error {
  font-size: 12px;
  color: hsl(0 70% 70%);
}

.cua-captured-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 4px;
}

/* ============================================================
   Standalone modal "sheet" — portaled to <body> so it escapes the
   floating panel's transform/opacity (which otherwise trap a
   position:fixed backdrop inside the ~400px panel). Shared by the
   workflow library, the run-params prompt, and the record → review →
   save wizard. Themed via --cop-* tokens, so it follows light/dark.
   ============================================================ */
.copilot-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10050;                 /* above the floating panel (z 10000) */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  background: var(--cop-scrim);
  backdrop-filter: blur(3px) saturate(115%);
  -webkit-backdrop-filter: blur(3px) saturate(115%);
  animation: copilot-sheet-fade 140ms ease-out;
}
@keyframes copilot-sheet-fade { from { opacity: 0; } to { opacity: 1; } }

.copilot-sheet {
  display: flex;
  flex-direction: column;
  width: clamp(320px, 92vw, 680px);
  max-height: min(88vh, 860px);
  background: linear-gradient(180deg, var(--cop-surface-14-94) 0%, var(--cop-bg-deep-glass) 100%);
  color: var(--cop-text-1);
  border: 1px solid var(--cop-border-14);
  border-radius: 16px;
  box-shadow:
    0 24px 64px var(--cop-shadow-45),
    0 2px 10px var(--cop-shadow-28),
    inset 0 1px 0 var(--cop-border-06);
  overflow: hidden;
  animation: copilot-sheet-rise 200ms cubic-bezier(.2,.7,.2,1);
}
.copilot-sheet--sm { width: clamp(300px, 90vw, 460px); }
.copilot-sheet--lg { width: clamp(320px, 94vw, 820px); }
@keyframes copilot-sheet-rise {
  from { opacity: 0; transform: translateY(10px) scale(.985); }
  to   { opacity: 1; transform: none; }
}

.copilot-sheet-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 22px;
  border-bottom: 1px solid var(--cop-border-08);
  background: var(--cop-surface-18-80);
}
.copilot-sheet-title {
  font: 600 16px/1.25 "IBM Plex Sans", system-ui, sans-serif;
  color: var(--cop-text);
  letter-spacing: -0.01em;
}
.copilot-sheet-close {
  flex: 0 0 auto;
  background: transparent;
  color: var(--cop-text-dim);
  border: 1px solid transparent;
  border-radius: 8px;
  width: 30px;
  height: 30px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  transition: background 120ms, color 120ms;
}
.copilot-sheet-close:hover { background: var(--cop-border-08); color: var(--cop-text); }

.copilot-sheet-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 22px;
}

.copilot-sheet-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid var(--cop-border-08);
  background: var(--cop-surface-16-96);
}
.copilot-sheet-footer--split { justify-content: space-between; }

/* Review/param/step rows: let the inputs shrink so the remove button is
   never clipped (the row is flex; without min-width:0 the inputs refuse to
   shrink below content width and push the ✕ off the edge). */
.cua-review-row > input,
.cua-review-row > .cua-review-prereq,
.cua-review-param-name,
.cua-review-param-desc,
.cua-review-step-intent {
  flex: 1 1;
  min-width: 0;
}
.cua-review-param-name { flex: 0 1 34%; }
.cua-review-step-uses { flex: 0 1 38%; min-width: 0; }
.cua-review-row-remove { flex: 0 0 auto; }

.cua-review-step-drag {
  flex: 0 0 auto;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  color: var(--cop-gray-55);
  font-size: 14px;
  line-height: 1;
  padding: 0 2px;
  align-self: center;
}
.cua-review-step-drag:active { cursor: grabbing; }

/* Roomier rhythm now that the sheet has space to breathe. */
.copilot-sheet-body .cua-review-form { gap: 18px; }
.copilot-sheet-body .cua-review-section { gap: 8px; }

/* Inside the sheet the body is the single scroll container — drop the
   modal-era width caps and the list's own scroll so they don't double up. */
.copilot-sheet-body .copilot-workflow-library {
  width: auto;
  max-height: none;
  gap: 14px;
}
.copilot-sheet-body .copilot-workflow-list {
  max-height: none;
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/copilot/copilot.css"],"names":[],"mappings":"AAAA;;;;;;iEAMiE;AACjE;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,mCAAmC;EACnC,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,2CAA2C;EAC3C,2CAA2C;EAC3C,yCAAyC;EACzC,2CAA2C;EAC3C,mCAAmC;EACnC,0CAA0C;EAC1C,0CAA0C;EAC1C,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,mCAAmC;EACnC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,0BAA0B;EAC1B,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,uCAAuC;EACvC,wCAAwC;EACxC,wCAAwC;EACxC,6CAA6C;EAC7C;;wEAEsE;EACtE,qBAAqB;EACrB,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;;;;;;;iEASiE;AACjE;EACE,gEAAgE;EAChE,kCAAkC;EAClC,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,mCAAmC;EACnC,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,2CAA2C;EAC3C,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,iEAAiE;EACjE,oCAAoC;EACpC,0CAA0C;EAC1C,gDAAgD;EAChD,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,qCAAqC;EACrC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,kEAAkE;EAClE,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,iCAAiC;EACjC,sCAAsC;EACtC,sCAAsC;EACtC,wBAAwB;EACxB,4BAA4B;EAC5B,mCAAmC;EACnC,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,gEAAgE;EAChE,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,gEAAgE;EAChE,8BAA8B;EAC9B,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,8EAA8E;EAC9E,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,6CAA6C;EAC7C,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;;;;;;;;;EAWE;;AAIF;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX;;;;;;uBAMqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB;uEACqE;EACrE;;;;;;;;4BAQ0B;EAC1B,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,+FAA+F;EAC/F,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB;;;sCAGoC;EACpC,+FAA+F;EAC/F,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;;EAEhB,0CAA0C;EAC1C,kDAAkD;EAClD;;oBAEkB;AACpB;;AAEA;;;sDAGsD;AACtD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;EACX;;;;qBAImB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX;;;qBAGmB;EACnB,0BAA0B;EAC1B,4CAA4C;AAC9C;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;;;;;4EAK4E;AAC5E;;;qBAGqB;AACrB;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;;;EAGE,aAAa;AACf;AACA;;oEAEoE;AACpE;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;;;;;;;uCAOuC;AACvC;EACE,SAAS;EACT,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB;iEAC+D;EAC/D;;;;;;wCAMsC;AACxC;;AAEA;;;;;;;;;;;wDAWwD;AACxD;EACE,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;;;;;;4BAM4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;;;;;;;;oEAQoE;AACpE;EACE,+BAA+B;AACjC;;AAEA;;;kEAGkE;AAClE;;EAEE,2BAA2B;AAC7B;;AAEA;;;;kCAIkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+FAA+F;EAC/F,iDAAiD;EACjD,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB;;;;mCAIiC;EACjC;;;yCAGuC;EACvC,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;yDACyD;AACzD;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,OAAO,0CAA0C,EAAE;EACnD,OAAO,0CAA0C,EAAE;EACnD,OAAO,wCAAwC,EAAE;AACnD;;AAEA;;kDAEkD;AAClD;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gEAAgE;AAClE;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;wCACwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,kFAAkF;AACpF;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;2BAC2B;AAC3B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;;;;4BAI4B;AAC5B;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB;;oCAEkC;EAClC,cAAc,GAAG,iDAAiD;EAClE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,oEAAoE;AACtE;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;AACf;;AAEA;;;;;;0DAM0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;;;;yEAIyE;AACzE;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;EACnB;;sCAEoC;EACpC,aAAa;EACb,wBAAwB;EACxB;;;kEAGgE;EAChE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB;;;iDAG+C;EAC/C,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;AACtC;AACA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA,qEAAqE;AACrE;;EAEE,MAAM;EACN,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;AACA,qBAAqB,OAAO,EAAE;AAC9B,qBAAqB,QAAQ,EAAE;;AAE/B;;+BAE+B;AAC/B;EACE,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;EACV,yBAAyB;AAC3B;AACA,kDAAkD;AAClD;;EAEE,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,2BAA2B;AAC7B;AACA,6BAA6B,SAAS,EAAE;AACxC,6BAA6B,UAAU,EAAE;AACzC,gDAAgD;AAChD;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,2BAA2B;AAC7B;AACA,gCAAgC,YAAY,EAAE;;AAE9C,wEAAwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;;;;;;;iCASiC;AACjC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB;;+CAE6C;EAC7C,0BAA0B;AAC5B;;AAEA;;;;mEAImE;AACnE;EACE;;;;;WAKS;AACX;;AAEA;;;;;wEAKwE;AACxE;;;EAGE,qBAAqB;EACrB,qDAAqD;AACvD;AACA,oCAAoC,UAAU,EAAE,WAAW,EAAE;AAC7D,0CAA0C,uBAAuB,EAAE;AACnE;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;;AAEA;;;kBAGkB;AAClB;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;WAKS;EACT;;;;gCAI8B;EAC9B,oBAAoB;AACtB;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,2DAA2D;EAC3D,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;AAClC;;AAEA;;;;;;;wCAOwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB;;;;4BAI0B;EAC1B,WAAW;EACX;;;yCAGuC;EACvC,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,2CAA2C;EAC3C,sDAAsD;EACtD,oBAAoB;AACtB;AACA;EACE,OAAO,2CAA2C,EAAE;EACpD,OAAO,2CAA2C,EAAE;EACpD,OAAO,wCAAwC,EAAE;AACnD;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sFAAsF;AACxF;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;EAClB,gEAAgE;AAClE;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;EACxC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;AACA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;wCAEwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kFAAkF;AACpF;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;mDAImD;AACnD;EACE,6CAA6C;AAC/C;AACA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,oFAAoF;EACpF,wBAAwB;EACxB,gDAAgD;AAClD;AACA,2CAA2C,sBAAsB,EAAE;AACnE,2CAA2C,sBAAsB,EAAE;AACnE,2CAA2C,sBAAsB,EAAE;AACnE,2CAA2C,sBAAsB,EAAE;AACnE,2CAA2C,sBAAsB,EAAE;AACnE;EACE,WAAW,WAAW,EAAE,YAAY,EAAE;EACtC,WAAW,YAAY,EAAE,UAAU,EAAE;AACvC;AACA;EACE,4EAA4E;EAC5E,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;;;iCAKiC;AACjC;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA,oEAAoE;AACpE,kCAAkC,YAAY,EAAE;;AAEhD,uEAAuE;AACvE;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;;;iEAIiE;AACjE;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,iCAAiC;EACjC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gDAAgD;AAClD;AACA;EACE,kCAAkC;EAClC,gDAAgD;AAClD;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;;4BAG4B;AAC5B;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,0BAA0B;EAC1B,kCAAkC;EAClC,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;6DAgB6D;AAC7D;;;;EAIE,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,uCAAuC;AACzC;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,mCAAmC;AACrC;AACA;;EAEE,6BAA6B;EAC7B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;;;;;;;;;uBASuB;AACvB;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;AACA;;;;EAIE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;;;oBAKoB;AACpB;;EAEE,wBAAwB;AAC1B;;AAEA,0EAA0E;AAC1E;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB;0EACwE;EACxE,WAAW;EACX;;4EAE0E;EAC1E,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;;AAEA;;;0EAG0E;AAC1E;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;gFAGgF;AAChF;EACE,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;kDAGkD;AAClD;EACE,cAAc;EACd,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,4BAA4B;EAC5B,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;;2BAG2B;AAC3B;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;2DAC2D;AAC3D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;;;;;;YAMY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,oCAAoC;EACpC,wBAAwB;EACxB,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;;mCAGmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;EACnB,oCAAoC;EACpC,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;EACf,0DAA0D;EAC1D;8CAC4C;EAC5C,SAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;;;;kCAIkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;;wCAIwC;AACxC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;EACf,4EAA4E;AAC9E;AACA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;oEACoE;AACpE;;EAEE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;;;;;;8EAM8E;;AAE9E;;EAEE,0EAA0E;EAC1E,oCAAoC;EACpC,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,2DAA2D;AAC7D;AACA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;;;;iEAIiE;;AAEjE;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,YAAY,EAAE;AAC3B;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yDAAyD;;AAEzD;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;EACpB,4CAA4C;EAC5C,yBAAyB;EACzB,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,mBAAmB,gBAAgB,EAAE;;AAErC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,uBAAuB,uBAAuB,EAAE;;AAEhD;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,kCAAkC,2BAA2B,EAAE;;AAE/D,uDAAuD;;AAEvD;;;iDAGiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gEAAgE;AAClE;AACA;EACE,kCAAkC;AACpC;AACA;EACE;2EACyE;EACzE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,uDAAuD;EACvD,sBAAsB;EACtB,eAAe;EACf;;oCAEkC;EAClC,kDAAkD;AACpD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;AACA,8EAA8E;AAC9E;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,8BAA8B,gCAAgC,EAAE;;AAEhE;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA,wBAAwB;;AAExB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA,uBAAuB,cAAc,EAAE,YAAY,EAAE;;AAErD,uBAAuB,gBAAgB,EAAE,yBAAyB,EAAE,eAAe,EAAE;AACrF,uBAAuB,eAAe,EAAE,yBAAyB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEpG;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;AAC3B;AACA,8BAA8B,4BAA4B,EAAE,uBAAuB,EAAE;AACrF,oCAAoC,0BAA0B,EAAE,qBAAqB,EAAE;;AAEvF,0BAA0B,aAAa,EAAE,QAAQ,EAAE;;AAEnD;EACE,gCAAgC;EAChC,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB,qBAAqB,EAAE;AAC7C,2BAA2B,6BAA6B,EAAE;AAC1D,4BAA4B,0BAA0B,EAAE;;AAExD,4CAA4C;;AAE5C;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,uDAAuD;EACvD,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA,0BAA0B;;AAE1B,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEvE;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA,iCAAiC,yBAAyB,EAAE;AAC5D,iCAAiC,+BAA+B,EAAE,gBAAgB,EAAE;AACpF,iCAAiC,uBAAuB,EAAE;;AAE1D;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uDAAuD;EACvD,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,oBAAoB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrE,0BAA0B,eAAe,EAAE,yBAAyB,EAAE;AACtE;;;;;;;;EAQE,gCAAgC;EAChC,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,yDAAyD;EACzD,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,+BAA+B;EAC/B,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;gEAEgE;;AAEhE,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;gBACgB;AAChB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;;wCAEwC,UAAU,EAAE;AACpD;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,WAAW;AACb;AACA;EACE,sDAAsD;EACtD,oBAAoB;AACtB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;wCACwC,UAAU,EAAE;AACpD,gCAAgC,0BAA0B,EAAE;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;AACA,0CAA0C,iBAAiB,EAAE;;AAE7D,2EAA2E;AAC3E;EACE,eAAe;EACf,QAAQ;EACR,cAAc,aAAa,4BAA4B;EACvD,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA,oBAAoB,yBAAyB,EAAE;;AAE/C,0BAA0B,gBAAgB,EAAE;;AAE5C;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kDAAkD;EAClD,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA,qCAAqC,qBAAqB,EAAE;;AAE5D;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;;;iEAMiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,cAAc,kBAAkB,uCAAuC;EACvE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,yCAAyC;EACzC,iDAAiD;EACjD,4CAA4C;AAC9C;AACA,gCAAgC,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAExE;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,+FAA+F;EAC/F,wBAAwB;EACxB,sCAAsC;EACtC,mBAAmB;EACnB;;;sCAGoC;EACpC,gBAAgB;EAChB,4DAA4D;AAC9D;AACA,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6CAA6C;EAC7C,oCAAoC;AACtC;AACA;EACE,0DAA0D;EAC1D,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;AACA,6BAA6B,gCAAgC,EAAE,sBAAsB,EAAE;;AAEvF;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;AACtC;AACA,+BAA+B,8BAA8B,EAAE;;AAE/D;;6DAE6D;AAC7D;;;;;EAKE,SAAW;EACX,YAAY;AACd;AACA,yBAAyB,aAAa,EAAE;AACxC,wBAAwB,aAAa,EAAE,YAAY,EAAE;AACrD,yBAAyB,cAAc,EAAE;;AAEzC;EACE,cAAc;EACd,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA,+BAA+B,gBAAgB,EAAE;;AAEjD,4DAA4D;AAC5D,uCAAuC,SAAS,EAAE;AAClD,0CAA0C,QAAQ,EAAE;;AAEpD;4EAC4E;AAC5E;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* ============================================================\n   Copilot theme tokens (Phase 1: structural surfaces/text/\n   borders/accent/shadow). Dark values below are the original\n   literals — the dark theme is unchanged. Light overrides live\n   in the [data-copilot-theme=\"light\"] block. Only --cop-* vars\n   are themed, so impact is scoped to copilot surfaces.\n   ============================================================ */\n:root {\n  --cop-bg-deepest: hsl(224 28% 8%);\n  --cop-bg-deep: hsl(224 28% 11%);\n  --cop-bg-deep-alt: hsl(226 24% 11%);\n  --cop-bg: hsl(224 28% 13%);\n  --cop-bg-15: hsl(224 28% 15%);\n  --cop-surface: hsl(224 28% 18%);\n  --cop-surface-2: hsl(224 28% 22%);\n  --cop-surface-3: hsl(224 28% 26%);\n  --cop-surface-4: hsl(224 28% 28%);\n  --cop-bg-glass-96: hsl(224 28% 13% / 0.96);\n  --cop-bg-glass-88: hsl(224 28% 13% / 0.88);\n  --cop-bg-glass-55: hsl(224 28% 13% / 0.55);\n  --cop-bg-fade: hsl(224 28% 13% / 0);\n  --cop-bg-deep-glass: hsl(224 28% 10% / 0.96);\n  --cop-surface-16-96: hsl(224 28% 16% / 0.96);\n  --cop-surface-14-94: hsl(224 28% 14% / 0.94);\n  --cop-surface-14-80: hsl(224 28% 14% / 0.8);\n  --cop-surface-18-80: hsl(224 28% 18% / 0.8);\n  --cop-border-navy: hsl(224 18% 32% / 0.7);\n  --cop-border-navy-2: hsl(224 18% 24% / 0.6);\n  --cop-scrim: hsl(224 28% 6% / 0.55);\n  --cop-scrim-strong: hsl(224 28% 4% / 0.86);\n  --cop-border-strong: hsl(0 0% 100% / 0.22);\n  --cop-border-18: hsl(0 0% 100% / 0.18);\n  --cop-border-16: hsl(0 0% 100% / 0.16);\n  --cop-border-14: hsl(0 0% 100% / 0.14);\n  --cop-border: hsl(0 0% 100% / 0.12);\n  --cop-border-10: hsl(0 0% 100% / 0.10);\n  --cop-border-08: hsl(0 0% 100% / 0.08);\n  --cop-border-06: hsl(0 0% 100% / 0.06);\n  --cop-border-05: hsl(0 0% 100% / 0.05);\n  --cop-border-04: hsl(0 0% 100% / 0.04);\n  --cop-border-03: hsl(0 0% 100% / 0.03);\n  --cop-fill-95: hsl(0 0% 100% / 0.95);\n  --cop-fill-86: hsl(0 0% 100% / 0.86);\n  --cop-fill-82: hsl(0 0% 100% / 0.82);\n  --cop-fill-74: hsl(0 0% 100% / 0.74);\n  --cop-fill-70: hsl(0 0% 100% / 0.70);\n  --cop-fill-65: hsl(0 0% 100% / 0.65);\n  --cop-fill-42: hsl(0 0% 100% / 0.42);\n  --cop-fill-35: hsl(0 0% 100% / 0.35);\n  --cop-fill-32: hsl(0 0% 100% / 0.32);\n  --cop-text: #fff;\n  --cop-text-bright: hsl(0 0% 100%);\n  --cop-text-1: #e7e9ee;\n  --cop-text-2: #cbd2e0;\n  --cop-text-muted: hsl(218 17% 80%);\n  --cop-text-muted-75: hsl(218 17% 75%);\n  --cop-text-muted-70: hsl(218 17% 70%);\n  --cop-text-muted-65: hsl(218 17% 65%);\n  --cop-text-dim: hsl(218 17% 60%);\n  --cop-gray-96: hsl(0 0% 96%);\n  --cop-gray-95: hsl(0 0% 95%);\n  --cop-gray-92: hsl(0 0% 92%);\n  --cop-gray-90: hsl(0 0% 90%);\n  --cop-gray-75: hsl(0 0% 75%);\n  --cop-gray-70: hsl(0 0% 70%);\n  --cop-gray-65: hsl(0 0% 65%);\n  --cop-gray-60: hsl(0 0% 60%);\n  --cop-gray-55: hsl(0 0% 55%);\n  --cop-gray-50: hsl(0 0% 50%);\n  --cop-accent: hsl(217 91% 53%);\n  --cop-accent-hover: hsl(217 91% 60%);\n  --cop-accent-bright: hsl(217 91% 75%);\n  --cop-accent-deep: hsl(217 91% 45%);\n  --cop-accent-alt: hsl(213 88% 64%);\n  --cop-accent-tint: #cfe0ff;\n  --cop-accent-60-60: hsl(217 91% 60% / 0.6);\n  --cop-accent-55: hsl(217 91% 53% / 0.55);\n  --cop-accent-42: hsl(217 91% 53% / 0.42);\n  --cop-accent-35: hsl(217 91% 53% / 0.35);\n  --cop-accent-28: hsl(217 91% 53% / 0.28);\n  --cop-accent-20: hsl(217 91% 53% / 0.2);\n  --cop-accent-16: hsl(217 91% 53% / 0.16);\n  --cop-accent-12: hsl(217 91% 53% / 0.12);\n  --cop-accent-deep-35: hsl(217 91% 30% / 0.35);\n  /* Text/icon ON a solid accent fill. The accent stays a saturated blue in\n     both themes, so this is white in both — it is deliberately NOT overridden\n     in the light block (text on a blue button must not flip to dark). */\n  --cop-on-accent: #fff;\n  --cop-shadow-60: rgba(0, 0, 0, 0.6);\n  --cop-shadow-45: hsl(0 0% 0% / 0.45);\n  --cop-shadow-40b: hsl(0 0% 0% / 0.4);\n  --cop-shadow-40: rgba(0, 0, 0, 0.4);\n  --cop-shadow-35: rgba(0, 0, 0, 0.35);\n  --cop-shadow-32: rgba(0, 0, 0, 0.32);\n  --cop-shadow-28: rgba(0, 0, 0, 0.28);\n  --cop-shadow-20: rgba(0, 0, 0, 0.20);\n  --cop-shadow-18: rgba(0, 0, 0, 0.18);\n}\n\n/* ============================================================\n   Light theme. Only redefines --cop-* tokens, so the host\n   Webconnect/Tokyo app is untouched. Applied via the\n   data-copilot-theme=\"light\" attribute on <html> (set by the\n   panel header toggle). Surfaces invert to a cool off-white\n   ladder; light text becomes dark; white-alpha borders/overlays\n   become dark-alpha; shadows soften.\n   Phase 2 (semantic banner hues) is still TODO — error/success/\n   warning blocks keep their dark-tuned literals for now.\n   ============================================================ */\n:root[data-copilot-theme=\"light\"] {\n  /* surfaces: page = light gray, cards = white, raised = grayer */\n  --cop-bg-deepest: hsl(220 16% 89%);\n  --cop-bg-deep: hsl(220 18% 92%);\n  --cop-bg-deep-alt: hsl(220 18% 92%);\n  --cop-bg: hsl(220 24% 97%);\n  --cop-bg-15: hsl(220 22% 96%);\n  --cop-surface: hsl(0 0% 100%);\n  --cop-surface-2: hsl(220 16% 95%);\n  --cop-surface-3: hsl(220 16% 91%);\n  --cop-surface-4: hsl(220 16% 88%);\n  --cop-bg-glass-96: hsl(220 24% 97% / 0.96);\n  --cop-bg-glass-88: hsl(220 24% 97% / 0.88);\n  --cop-bg-glass-55: hsl(220 24% 97% / 0.55);\n  --cop-bg-fade: hsl(220 24% 97% / 0);\n  --cop-bg-deep-glass: hsl(220 18% 92% / 0.96);\n  --cop-surface-16-96: hsl(220 20% 96% / 0.96);\n  --cop-surface-14-94: hsl(220 20% 95% / 0.94);\n  --cop-surface-14-80: hsl(220 20% 95% / 0.8);\n  --cop-surface-18-80: hsl(0 0% 100% / 0.8);\n  --cop-border-navy: hsl(220 14% 60% / 0.55);\n  --cop-border-navy-2: hsl(220 14% 65% / 0.5);\n  /* modal scrims stay a dark dim so the dialog pops on light too */\n  --cop-scrim: hsl(220 24% 18% / 0.32);\n  --cop-scrim-strong: hsl(220 24% 18% / 0.5);\n  /* borders: black-alpha instead of white-alpha */\n  --cop-border-strong: hsl(220 20% 20% / 0.24);\n  --cop-border-18: hsl(220 20% 20% / 0.18);\n  --cop-border-16: hsl(220 20% 20% / 0.15);\n  --cop-border-14: hsl(220 20% 20% / 0.13);\n  --cop-border: hsl(220 20% 20% / 0.12);\n  --cop-border-10: hsl(220 20% 20% / 0.10);\n  --cop-border-08: hsl(220 20% 20% / 0.09);\n  --cop-border-06: hsl(220 20% 20% / 0.07);\n  --cop-border-05: hsl(220 20% 20% / 0.06);\n  --cop-border-04: hsl(220 20% 20% / 0.05);\n  --cop-border-03: hsl(220 20% 20% / 0.04);\n  /* fills used as text (color:) — dim DARK text at matching alpha */\n  --cop-fill-95: hsl(220 25% 16% / 0.95);\n  --cop-fill-86: hsl(220 25% 16% / 0.86);\n  --cop-fill-82: hsl(220 25% 16% / 0.82);\n  --cop-fill-74: hsl(220 20% 20% / 0.74);\n  --cop-fill-70: hsl(220 20% 22% / 0.70);\n  --cop-fill-65: hsl(220 18% 26% / 0.68);\n  --cop-fill-42: hsl(220 16% 30% / 0.55);\n  /* fills used as overlay/border */\n  --cop-fill-35: hsl(220 20% 20% / 0.14);\n  --cop-fill-32: hsl(220 20% 20% / 0.22);\n  /* text: light -> dark */\n  --cop-text: hsl(220 26% 14%);\n  --cop-text-bright: hsl(220 30% 10%);\n  --cop-text-1: hsl(220 22% 18%);\n  --cop-text-2: hsl(220 16% 30%);\n  --cop-text-muted: hsl(218 14% 36%);\n  --cop-text-muted-75: hsl(218 13% 40%);\n  --cop-text-muted-70: hsl(218 13% 44%);\n  --cop-text-muted-65: hsl(218 12% 48%);\n  --cop-text-dim: hsl(218 12% 50%);\n  /* gray ladder: light-grays (text/icons on dark) -> dark-grays */\n  --cop-gray-96: hsl(0 0% 16%);\n  --cop-gray-95: hsl(0 0% 18%);\n  --cop-gray-92: hsl(0 0% 22%);\n  --cop-gray-90: hsl(0 0% 26%);\n  --cop-gray-75: hsl(0 0% 36%);\n  --cop-gray-70: hsl(0 0% 40%);\n  --cop-gray-65: hsl(0 0% 44%);\n  --cop-gray-60: hsl(0 0% 46%);\n  --cop-gray-55: hsl(0 0% 50%);\n  --cop-gray-50: hsl(0 0% 50%);\n  /* accent: darken slightly for contrast against white surfaces */\n  --cop-accent: hsl(217 91% 48%);\n  --cop-accent-hover: hsl(217 91% 42%);\n  --cop-accent-bright: hsl(217 80% 44%);\n  --cop-accent-deep: hsl(217 91% 40%);\n  --cop-accent-alt: hsl(213 80% 46%);\n  --cop-accent-tint: hsl(217 70% 42%);\n  /* accent alphas (tinted bg/border) read fine on light; keep hue, same alpha */\n  --cop-accent-60-60: hsl(217 91% 48% / 0.5);\n  --cop-accent-55: hsl(217 91% 48% / 0.18);\n  --cop-accent-42: hsl(217 91% 48% / 0.16);\n  --cop-accent-35: hsl(217 91% 48% / 0.14);\n  --cop-accent-28: hsl(217 91% 48% / 0.16);\n  --cop-accent-20: hsl(217 91% 48% / 0.12);\n  --cop-accent-16: hsl(217 91% 48% / 0.10);\n  --cop-accent-12: hsl(217 91% 48% / 0.10);\n  --cop-accent-deep-35: hsl(217 70% 60% / 0.35);\n  /* shadows: soften for light mode */\n  --cop-shadow-60: rgba(0, 0, 0, 0.18);\n  --cop-shadow-45: hsl(0 0% 0% / 0.14);\n  --cop-shadow-40b: hsl(0 0% 0% / 0.12);\n  --cop-shadow-40: rgba(0, 0, 0, 0.12);\n  --cop-shadow-35: rgba(0, 0, 0, 0.10);\n  --cop-shadow-32: rgba(0, 0, 0, 0.10);\n  --cop-shadow-28: rgba(0, 0, 0, 0.08);\n  --cop-shadow-20: rgba(0, 0, 0, 0.06);\n  --cop-shadow-18: rgba(0, 0, 0, 0.05);\n}\n\n/* Surrounding chrome for the copilot panel — the floating right-side dock,\n * its draggable header, resize handles, dock mode, idle-fade behaviour, and\n * the start-error toast. The conversation surface (welcome / messages /\n * composer) is rendered by the assistant-ui-driven Thread family in\n * src/copilot/assistant-ui/ using Tailwind utilities; rules that styled those\n * elements previously have been removed.\n *\n * Typography note: IBM Plex Sans + Plex Mono are loaded from Google Fonts.\n * The panel is feature-flagged so the fonts only download when a user opens\n * Copilot for the first time. For Electron offline distribution we'd bundle\n * the woff2 files locally — out of scope for this PR.\n */\n\n@import url(\"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600&family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Serif:ital,wght@1,500;1,600&display=swap\");\n\n.copilot-panel {\n  position: fixed;\n  top: 80px;\n  right: 16px;\n  /* Webconnect's .the-topbar (our mount-point ancestor) sets\n   * user-select:none on itself, and the property inherits. Without an\n   * explicit override here, every chat bubble, action card, and message\n   * inside the panel is non-selectable — so the user can't copy code\n   * blocks or assistant text. Setting :text breaks the inheritance for\n   * the panel body; the header still wins with its own :none rule for\n   * the drag handle. */\n  user-select: text;\n  -webkit-user-select: text;\n  /* width is set inline from React (userWidth state) so it survives dock\n   * toggles. Default lives in the React component (PANEL_DEFAULT_W). */\n  /* Definite height (not just max-height): the floating composer is\n   * positioned absolute relative to ThreadPrimitive.Root, and Root takes\n   * the remaining vertical space via flex:1/min-h-0 inside this flex\n   * column. A definite parent height anchors the flex chain — with only\n   * max-height the chain falls back to content-sized, the composer rides\n   * the bottom of the growing conversation, and once content exceeds\n   * max-height the composer clips out via overflow:hidden. min() caps the\n   * panel at either 720px (comfortable on tall monitors) or vh-100,\n   * whichever is smaller. */\n  height: min(720px, calc(100vh - 100px));\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(180deg, var(--cop-surface-14-94) 0%, var(--cop-bg-deep-glass) 100%);\n  color: var(--cop-text-1);\n  border: 1px solid var(--cop-border-10);\n  border-radius: 12px;\n  box-shadow:\n    0 10px 28px var(--cop-shadow-32),\n    0 1px 3px var(--cop-shadow-18),\n    inset 0 1px 0 var(--cop-border-04);\n  font-family: \"IBM Plex Sans\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 13px;\n  line-height: 1.45;\n  z-index: 10000;\n  overflow: hidden;\n\n  backdrop-filter: blur(16px) saturate(140%);\n  -webkit-backdrop-filter: blur(16px) saturate(140%);\n  transition:\n    border-color 140ms,\n    box-shadow 140ms;\n}\n\n/* Top-edge brand-blue stripe. At rest it's a static hairline. While the\n * controller is busy (.copilot-panel--thinking), it thickens slightly and\n * animates as a left-to-right scan — ambient signal that the agent is\n * working without yanking focus to a modal/spinner. */\n.copilot-panel::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 18px;\n  right: 18px;\n  height: 1px;\n  background: linear-gradient(90deg,\n    transparent 0%,\n    var(--cop-accent-55) 20%,\n    var(--cop-accent-55) 80%,\n    transparent 100%);\n  background-size: 100% 100%;\n  background-position: 0 0;\n  pointer-events: none;\n  transition: height 200ms ease;\n}\n.copilot-panel--thinking::before {\n  height: 2px;\n  background: linear-gradient(90deg,\n    transparent 0%,\n    var(--cop-accent-hover) 50%,\n    transparent 100%);\n  background-size: 200% 100%;\n  animation: copilot-scan 1.6s linear infinite;\n}\n@keyframes copilot-scan {\n  from { background-position: 200% 0; }\n  to   { background-position: -200% 0; }\n}\n\n/* ----- mini mode -----\n * Collapses the panel to just the header + composer, hiding the conversation\n * thread. Useful when the user wants to keep the panel \"on\" but reclaim VM\n * viewport real estate. Works in both floating and docked modes — height\n * shrinks to fit the remaining content (header + composer), bottom anchor\n * is released so the panel doesn't try to stretch to the viewport bottom. */\n/* Recording in progress: hide the whole panel (chrome included) so only the\n   floating pill shows. ChatPanel stays mounted — it portals the pill to\n   <body>, outside this hidden subtree — so the panel reappears intact when\n   recording stops. */\n.copilot-panel--recording {\n  display: none !important;\n}\n\n.copilot-panel--mini {\n  height: auto !important;\n  bottom: auto !important;\n  max-height: none !important;\n}\n.copilot-panel--mini .copilot-thread-viewport,\n.copilot-panel--mini .copilot-thread-feather,\n.copilot-panel--mini .copilot-scroll-pip {\n  display: none;\n}\n/* In mini mode the composer is the panel's sole content surface — switch it\n * out of absolute positioning so it flows naturally below the header, and\n * give it real padding instead of the absolute-mode 12px offsets. */\n.copilot-panel--mini .copilot-composer-layer {\n  position: static;\n  padding: 10px 12px 12px;\n  left: auto;\n  right: auto;\n  bottom: auto;\n}\n.copilot-panel--mini .copilot-chat-panel {\n  min-height: 0;\n}\n\n/* ----- dock mode -----\n * Sits flush below the denver toolbar (top measured at runtime by the React\n * component and applied inline) and stretches to the viewport bottom. We\n * have to override `height` here because the base .copilot-panel rule sets\n * a min(720px, vh-100) cap to make the floating composer anchor correctly;\n * left at that cap the docked panel would only be 720px tall regardless of\n * the available vertical space. Setting height:auto + bottom:0 lets the\n * top/bottom anchors size the panel. */\n.copilot-panel--docked {\n  top: 60px;\n  right: 0;\n  bottom: 0;\n  height: auto;\n  max-height: calc(100vh - 60px);\n  border-radius: 0;\n  border-right: 0;\n  border-top: 1px solid var(--cop-border-10);\n  border-bottom: 0;\n  /* dock toggle is animated; transform is suspended (no dx/dy applied in\n   * docked mode), so width/right/top transitions land cleanly. */\n  transition:\n    opacity 260ms cubic-bezier(.2,.7,.2,1) 180ms,\n    backdrop-filter 260ms ease 180ms,\n    -webkit-backdrop-filter 260ms ease 180ms,\n    width 240ms cubic-bezier(.2,.7,.2,1),\n    top 240ms cubic-bezier(.2,.7,.2,1),\n    right 240ms cubic-bezier(.2,.7,.2,1);\n}\n\n/* ----- side-by-side dock: shrink the right section so the VM iframe\n * stops sitting underneath the docked panel. CopilotButton sets\n * data-copilot-docked + --copilot-dock-w on <body> when the dock toggle\n * is on; the value tracks userWidth so dragging the west resize handle\n * pulls the iframe in/out with the panel. margin-right (not width) is\n * deliberate: .the-right-section is flex:1 inside .the-main-row, so\n * margin pushes the flex track inward without fighting flex-grow.\n *\n * The Guacamole canvas inside the iframe needs an explicit resync\n * (resize.js#inject_resize) — CopilotButton dispatches a window resize\n * event whenever this var changes, and resize.js's 400 ms debounce\n * collapses drag bursts to a single VM canvas update. */\nbody[data-copilot-docked=\"1\"] .the-right-section {\n  margin-right: var(--copilot-dock-w, 0px);\n  transition: margin-right 240ms cubic-bezier(.2,.7,.2,1);\n}\n\n/* While the user is actively dragging a copilot panel resize handle, neuter\n * pointer events on the VM iframe. Without this the Guacamole canvas\n * preempts the parent doc's pointer-capture the moment the cursor crosses\n * into the iframe area (a hair to the left of the west handle in docked\n * mode), and the drag locks up after a single pixel. Scoped to the drag\n * only — CopilotButton sets data-copilot-resizing on pointerdown and\n * clears it on pointerup. */\nbody[data-copilot-resizing=\"1\"] .webconnect-frame {\n  pointer-events: none;\n}\n\n/* webpack-dev-server v4+ injects a full-viewport iframe\n * (#webpack-dev-server-client-overlay) at z-index 2147483647 that stays\n * in the DOM after first showing a compile warning, with no error UI\n * inside but pointer-events:auto. It silently eats clicks on anything\n * portaled to <body> — including this panel's overflow menu, which has\n * no stacking-context shelter once outside .copilot-panel. Dev-only:\n * the iframe doesn't exist in production builds, so this rule is a\n * no-op in prod. Verified via document.elementsFromPoint at the menu\n * coords returning the overlay iframe instead of the menu button. */\n#webpack-dev-server-client-overlay {\n  pointer-events: none !important;\n}\n\n/* Kill width/margin transitions during an active drag — otherwise the\n * panel and iframe both lerp 240ms behind the pointer and the drag feels\n * laggy. The transitions are what we want on the dock TOGGLE itself\n * (animated slide-in/out), just not while the user is dragging. */\nbody[data-copilot-resizing=\"1\"] .copilot-panel,\nbody[data-copilot-resizing=\"1\"] .the-right-section {\n  transition: none !important;\n}\n\n/* ----- header -----\n * One row: identity → optional pinned tag + status dot → slot picker\n * → primary action icons (workflows, new conversation, overflow, close).\n * Theme/dock/minimize/compact are stashed in the overflow menu so the\n * primary chrome stays minimal. */\n.copilot-panel-header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: linear-gradient(180deg, var(--cop-surface-18-80) 0%, var(--cop-surface-14-80) 100%);\n  border-bottom: 1px solid var(--cop-border-navy-2);\n  cursor: move;\n  user-select: none;\n  touch-action: none;\n  min-height: 44px;\n}\n.copilot-panel--docked .copilot-panel-header {\n  cursor: default;\n}\n\n.copilot-panel-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.005em;\n  color: var(--cop-text);\n  min-width: 0;\n  flex: 0 1 auto;\n}\n\n/* Sparkle chip: brand-tinted disc with the lucide Sparkles icon. */\n.copilot-panel-title-glyph {\n  display: inline-grid;\n  place-items: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 999px;\n  background:\n    radial-gradient(circle at 30% 28%,\n      hsl(217 91% 60% / 0.95) 0%,\n      hsl(217 91% 45% / 0.85) 55%,\n      hsl(217 91% 38% / 0.85) 100%);\n  box-shadow:\n    0 0 0 1px hsl(217 91% 72% / 0.35),\n    0 1px 6px hsl(217 91% 30% / 0.45),\n    inset 0 1px 0 hsl(217 91% 80% / 0.35);\n  color: #fff;\n  flex-shrink: 0;\n}\n.copilot-panel-title-glyph-icon {\n  width: 14px;\n  height: 14px;\n  stroke-width: 2.25;\n}\n\n.copilot-panel-title-text {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n\n/* Status dot — small, lives next to the title; replaces the bigger\n * \"Connected\" pulse strip from the old two-row header. */\n.copilot-panel-pulse-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: hsl(140 60% 52%);\n  box-shadow: 0 0 0 0 hsl(140 60% 50% / 0.6);\n  animation: copilot-pulse 2s infinite;\n  flex-shrink: 0;\n  margin-left: 2px;\n}\n@keyframes copilot-pulse {\n  0%   { box-shadow: 0 0 0 0 hsl(140 60% 50% / 0.5); }\n  70%  { box-shadow: 0 0 0 8px hsl(140 60% 50% / 0); }\n  100% { box-shadow: 0 0 0 0 hsl(140 60% 50% / 0); }\n}\n\n/* Profile slot picker — single-row pill, native chevron kept so it\n * reads as a dropdown. Auto-pushes right via margin-left so it sits\n * between the title block and the action icons. */\n.copilot-panel-slot {\n  background: var(--cop-surface);\n  color: var(--cop-text);\n  border: 1px solid var(--cop-border-navy);\n  border-radius: 6px;\n  padding: 4px 6px 4px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  line-height: 1;\n  margin-left: auto;\n  transition: border-color 120ms ease, background-color 120ms ease;\n}\n.copilot-panel-slot:hover:not(:disabled) {\n  background: var(--cop-surface-2);\n  border-color: var(--cop-accent-42);\n}\n.copilot-panel-slot:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* When the slot picker is absent (single-slot grants), push the\n * controls to the right edge instead. */\n.copilot-panel-controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-left: auto;\n}\n.copilot-panel-slot ~ .copilot-panel-controls {\n  margin-left: 0;\n}\n\n.copilot-panel-btn {\n  background: transparent;\n  color: var(--cop-text-2);\n  border: 1px solid transparent;\n  border-radius: 6px;\n  padding: 5px;\n  font-size: 12px;\n  cursor: pointer;\n  line-height: 0;\n  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;\n}\n\n.copilot-panel-btn:hover:not(:disabled) {\n  background: var(--cop-surface-2);\n  color: var(--cop-text);\n}\n\n.copilot-panel-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.copilot-panel-btn--icon {\n  display: inline-grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n}\n\n.copilot-panel-btn--close:hover:not(:disabled) {\n  background: hsl(0 60% 50% / 0.18);\n  color: hsl(0 0% 100%);\n}\n\n.copilot-panel-icon {\n  width: 15px;\n  height: 15px;\n  stroke-width: 2;\n}\n\n/* Overflow ⋯ menu. Anchored under the trigger; absolute so it stacks\n * over the conversation. */\n.copilot-panel-overflow {\n  position: relative;\n  display: inline-block;\n}\n/* Portaled to <body>, anchored via inline top/right computed from the\n * trigger button's getBoundingClientRect. Fixed positioning escapes the\n * panel's overflow:hidden + transform (which would clip an in-place\n * absolute/fixed dropdown), so the menu is visible even when the panel\n * is shrunk to mini mode. */\n.copilot-panel-overflow-menu {\n  position: fixed;\n  min-width: 200px;\n  padding: 6px;\n  background: var(--cop-surface);\n  border: 1px solid var(--cop-border-navy-2);\n  border-radius: 10px;\n  box-shadow:\n    0 12px 32px hsl(220 30% 4% / 0.45),\n    0 2px 6px hsl(220 30% 4% / 0.35);\n  z-index: 10010;  /* sits above the panel itself (z-index: 10000) */\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  cursor: default;\n  /* Override the header's drag cursor so menu items feel clickable. */\n}\n.copilot-panel-overflow-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 10px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--cop-text);\n  font-size: 12.5px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 100ms ease;\n}\n.copilot-panel-overflow-item:hover {\n  background: var(--cop-surface-2);\n}\n.copilot-panel-overflow-item[aria-pressed=\"true\"] {\n  color: var(--cop-accent-alt);\n}\n.copilot-panel-overflow-item .copilot-panel-icon {\n  opacity: 0.85;\n}\n\n/* ----- in-panel confirm modal -----\n * Used for destructive header actions (e.g. profile-slot switch which\n * clears the conversation). Scoped inside .copilot-panel so it doesn't\n * cover the rest of Webconnect, and the backdrop has its own pointer\n * surface so clicking outside the dialog dismisses it. Click on the\n * dialog body itself stops propagation in JS so the backdrop dismiss\n * doesn't fire when the user clicks the modal contents. */\n.copilot-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  background: var(--cop-scrim);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 20;\n  /* Don't leak outside the rounded panel corners. */\n  border-radius: inherit;\n}\n\n/* Fullscreen variant — used when the modal is rendered outside the Copilot\n * panel (e.g. the repin chooser that fires from the TopBar button). The\n * default backdrop is positioned absolute to overlay just the panel; this\n * variant pins to the viewport instead so the modal isn't clipped by the\n * topbar's bounds. Sits above Denver's chrome (TopBar z-index is ~10). */\n.copilot-modal-backdrop--fullscreen {\n  position: fixed;\n  z-index: 1000;\n}\n.copilot-modal {\n  width: min(320px, calc(100% - 32px));\n  background: var(--cop-bg);\n  border: 1px solid var(--cop-border);\n  border-radius: 10px;\n  box-shadow:\n    0 12px 32px var(--cop-shadow-40),\n    inset 0 1px 0 var(--cop-border-05);\n  padding: 16px;\n  color: var(--cop-text-1);\n  /* The modal is mounted alongside .copilot-root (not inside it), so the\n   * inherited white-space:nowrap from the surrounding aux-buttons menu\n   * still applies. Reset it here so paragraph text wraps inside the\n   * 320px-wide dialog. text-align is reset for the same reason. */\n  white-space: normal;\n  text-align: left;\n}\n.copilot-modal-title {\n  margin: 0 0 8px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n.copilot-modal-body {\n  margin: 0 0 14px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--cop-text-muted-75);\n}\n.copilot-modal-body strong {\n  color: var(--cop-text);\n  font-weight: 600;\n}\n.copilot-modal-buttons {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n.copilot-modal-btn {\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n  line-height: 1.2;\n  /* Opt out of the chat panel's break-anywhere policy (set on .copilot-root\n   * for pathological URLs / hex tokens). Without these, short labels like\n   * \"Run\" can be wrapped letter-by-letter when the button is a shrinkable\n   * flex item next to a content-heavy sibling. */\n  white-space: nowrap;\n  overflow-wrap: normal;\n  flex-shrink: 0;\n}\n.copilot-modal-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.copilot-modal-btn--ghost {\n  background: transparent;\n  color: var(--cop-text-2);\n  border-color: var(--cop-border-navy);\n}\n.copilot-modal-btn--ghost:hover:not(:disabled) {\n  background: var(--cop-surface-2);\n  color: var(--cop-text);\n}\n.copilot-modal-btn--primary {\n  background: var(--cop-accent);\n  color: var(--cop-on-accent);\n}\n.copilot-modal-btn--primary:hover:not(:disabled) {\n  background: var(--cop-accent-hover);\n}\n.copilot-modal-btn--danger {\n  background: transparent;\n  color: hsl(0 70% 75%);\n  border-color: hsl(0 40% 35%);\n}\n.copilot-modal-btn--danger:hover {\n  background: hsl(0 40% 18%);\n  color: hsl(0 75% 82%);\n}\n\n/* ----- resize handles ----- */\n.copilot-resize {\n  position: absolute;\n  z-index: 1;\n  touch-action: none;\n}\n/* West/East edges are vertical strips along the full panel height. */\n.copilot-resize--w,\n.copilot-resize--e {\n  top: 0;\n  bottom: 0;\n  width: 6px;\n  cursor: ew-resize;\n}\n.copilot-resize--w { left: 0; }\n.copilot-resize--e { right: 0; }\n\n/* South edge is a horizontal strip along the bottom. Stops short of the\n * left/right handles so corner-grabs prefer the width handles (which feel\n * more natural at a corner). */\n.copilot-resize--s {\n  left: 6px;\n  right: 6px;\n  bottom: 0;\n  height: 6px;\n  cursor: ns-resize;\n}\n\n.copilot-resize::before {\n  content: \"\";\n  position: absolute;\n  border-radius: 2px;\n  background: var(--cop-border-strong);\n  opacity: 0;\n  transition: opacity 140ms;\n}\n/* Vertical edges: 2x36 grip centred vertically. */\n.copilot-resize--w::before,\n.copilot-resize--e::before {\n  top: 50%;\n  width: 2px;\n  height: 36px;\n  transform: translateY(-50%);\n}\n.copilot-resize--w::before { left: 1px; }\n.copilot-resize--e::before { right: 1px; }\n/* South edge: 36x2 grip centred horizontally. */\n.copilot-resize--s::before {\n  left: 50%;\n  bottom: 1px;\n  width: 36px;\n  height: 2px;\n  transform: translateX(-50%);\n}\n.copilot-resize:hover::before { opacity: 0.7; }\n\n/* Conversation surface wrapper — flex container that fills the panel. */\n.copilot-chat-panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  position: relative;\n}\n\n/* Defeat inherited typography rules from the surrounding menu. CopilotButton\n * mounts the panel inside `<ul#the-menu-items class=\"aux-buttons\">`, which\n * sets `white-space: nowrap` (to keep toolbar items on one line) and\n * `text-align: right` (to right-align the toolbar). Both cascade into the\n * panel content — nowrap turns paragraphs into single-line strips and\n * text-align:right pushes message text + JSON dumps to the right edge of\n * each bubble. Resetting at the panel root is enough; block descendants\n * inherit these unless they opt in explicitly. overflow-wrap lets\n * pathological strings (long URLs, hex tokens) break inside bubbles\n * instead of blowing them out. */\n.copilot-root {\n  white-space: normal;\n  text-align: left;\n  overflow-wrap: anywhere;\n  /* Composer publishes its current height here via ResizeObserver. The\n   * thread viewport consumes it as padding-bottom so the last message\n   * never hides under the floating composer. */\n  --copilot-composer-h: 72px;\n}\n\n/* Thread viewport reserves bottom space for the floating composer AND any\n * stacked strips above it: plan-progress (--copilot-plan-h), Guide-mode\n * permission card (--copilot-permission-h), and Guide-step advance chip\n * (--copilot-guide-advance-h). Each var resolves to 0px when its component\n * is not mounted, so the padding stays tight in the common case. */\n.copilot-thread-viewport {\n  padding-bottom: calc(\n    var(--copilot-composer-h)\n    + var(--copilot-plan-h, 0px)\n    + var(--copilot-permission-h, 0px)\n    + var(--copilot-guide-advance-h, 0px)\n    + 48px);\n}\n\n/* Thin custom scrollbars inside the panel — the OS default (~14-16px on\n * Windows) is too wide for a 400px-wide chat surface. Firefox uses\n * scrollbar-width/scrollbar-color on the scrollable itself; WebKit/Blink\n * uses ::-webkit-scrollbar pseudos which we scope to descendants so any\n * scrollable inside the panel (thread viewport, composer textarea, action\n * card JSON dumps) gets the same treatment without per-element rules. */\n.copilot-thread-viewport,\n.copilot-composer-wrap textarea,\n.copilot-action__details {\n  scrollbar-width: thin;\n  scrollbar-color: var(--cop-border-strong) transparent;\n}\n.copilot-root ::-webkit-scrollbar { width: 6px; height: 6px; }\n.copilot-root ::-webkit-scrollbar-track { background: transparent; }\n.copilot-root ::-webkit-scrollbar-thumb {\n  background: var(--cop-border-strong);\n  border-radius: 3px;\n}\n.copilot-root ::-webkit-scrollbar-thumb:hover {\n  background: var(--cop-fill-35);\n}\n\n/* Feather gradient that fades the last bit of the thread under the composer\n * instead of clipping it abruptly. Positioned over the viewport bottom; its\n * height tracks the composer height so the fade always covers the reserved\n * padding area. */\n.copilot-thread-feather {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: calc(\n    var(--copilot-composer-h)\n    + var(--copilot-plan-h, 0px)\n    + var(--copilot-permission-h, 0px)\n    + var(--copilot-guide-advance-h, 0px)\n    + 56px);\n  background: linear-gradient(180deg,\n    var(--cop-bg-fade) 0%,\n    var(--cop-bg-glass-55) 35%,\n    var(--cop-bg-glass-88) 65%,\n    var(--cop-bg-glass-96) 100%);\n  pointer-events: none;\n}\n\n/* Floating composer layer — sibling of the scroll viewport, never scrolls. */\n.copilot-composer-layer {\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Composer wrap holds the input + the keyboard-hint footer. */\n.copilot-composer-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* Scroll-to-bottom pip floats just above the composer, right-aligned. */\n.copilot-scroll-pip {\n  position: absolute;\n  right: 4px;\n  bottom: calc(100% + 6px);\n}\n\n/* Keyboard hint strip below the composer. */\n.copilot-composer-hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 4px;\n  font-size: 10.5px;\n  color: var(--cop-text-dim);\n  letter-spacing: 0.04em;\n}\n.copilot-composer-hint kbd {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 10px;\n  background: var(--cop-border-06);\n  border: 1px solid var(--cop-border-10);\n  border-bottom-width: 2px;\n  border-radius: 4px;\n  padding: 0 5px;\n  color: var(--cop-text-muted-75);\n}\n.copilot-composer-hint-sep {\n  width: 1px;\n  height: 10px;\n  background: var(--cop-border-10);\n}\n\n/* ----- Welcome / empty-state surface -----\n * Shown when the thread has no messages yet. Centered hero (sparkle disc +\n * heading + subtitle), three suggestion chips, then an optional\n * \"Recent workflows\" rail. All sizes scale modestly; the rail can be\n * absent (loading / none yet), so the hero stays self-sufficient.\n *\n * Tokens are read from --cop-* + the shadcn vars on .copilot-root so the\n * light theme switches automatically. */\n.copilot-welcome {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 20px;\n  padding: 28px 20px 16px;\n  max-width: 440px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.copilot-welcome-hero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  text-align: center;\n}\n\n.copilot-welcome-glyph {\n  display: inline-grid;\n  place-items: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 999px;\n  background:\n    radial-gradient(circle at 30% 28%,\n      hsl(213 88% 70%) 0%,\n      hsl(217 91% 55%) 55%,\n      hsl(217 91% 42%) 100%);\n  color: #fff;\n  box-shadow:\n    0 0 0 1px hsl(217 91% 72% / 0.35),\n    0 6px 16px hsl(217 91% 28% / 0.45),\n    inset 0 1px 0 hsl(213 88% 90% / 0.45);\n  position: relative;\n}\n.copilot-welcome-glyph::after {\n  /* subtle pulse halo */\n  content: \"\";\n  position: absolute;\n  inset: -6px;\n  border-radius: inherit;\n  box-shadow: 0 0 0 0 hsl(217 91% 60% / 0.45);\n  animation: copilot-welcome-halo 3.2s ease-out infinite;\n  pointer-events: none;\n}\n@keyframes copilot-welcome-halo {\n  0%   { box-shadow: 0 0 0 0 hsl(217 91% 60% / 0.45); }\n  70%  { box-shadow: 0 0 0 12px hsl(217 91% 60% / 0); }\n  100% { box-shadow: 0 0 0 0 hsl(217 91% 60% / 0); }\n}\n.copilot-welcome-glyph-icon {\n  width: 22px;\n  height: 22px;\n  stroke-width: 2;\n}\n\n.copilot-welcome-title {\n  margin: 4px 0 0;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  color: var(--cop-text);\n}\n\n.copilot-welcome-subtitle {\n  margin: 0;\n  max-width: 36ch;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--cop-text-muted-70);\n}\n.copilot-welcome-subtitle em {\n  font-style: italic;\n  color: var(--cop-text);\n}\n\n.copilot-welcome-suggestions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 6px;\n}\n.copilot-welcome-chip {\n  display: block;\n  width: 100%;\n  padding: 11px 14px;\n  background: var(--cop-surface);\n  color: var(--cop-text);\n  border: 1px solid var(--cop-border-navy);\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 120ms ease, border-color 120ms ease, transform 120ms ease;\n}\n.copilot-welcome-chip:hover {\n  background: var(--cop-surface-2);\n  border-color: var(--cop-accent-42);\n}\n.copilot-welcome-chip:active {\n  transform: translateY(1px);\n}\n.copilot-welcome-chip:focus-visible {\n  outline: 2px solid var(--cop-accent-42);\n  outline-offset: 2px;\n}\n\n/* Recent workflows rail */\n.copilot-welcome-recent {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 6px;\n}\n.copilot-welcome-recent-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 4px;\n}\n.copilot-welcome-recent-title {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--cop-text-muted-70);\n}\n.copilot-welcome-recent-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  background: transparent;\n  border: 0;\n  padding: 2px 4px;\n  font-size: 11.5px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  color: var(--cop-text-muted-70);\n  cursor: pointer;\n  border-radius: 4px;\n}\n.copilot-welcome-recent-link:hover {\n  color: var(--cop-accent-alt);\n}\n.copilot-welcome-recent-link-icon {\n  width: 13px;\n  height: 13px;\n  stroke-width: 2.25;\n}\n.copilot-welcome-recent-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.copilot-welcome-recent-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px 9px 11px;\n  background: var(--cop-surface);\n  border: 1px solid var(--cop-border-navy);\n  border-radius: 8px;\n  transition: background-color 120ms ease, border-color 120ms ease;\n}\n.copilot-welcome-recent-row:hover {\n  background: var(--cop-surface-2);\n  border-color: var(--cop-accent-42);\n}\n.copilot-welcome-recent-row-icon {\n  display: inline-grid;\n  place-items: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: var(--cop-accent-16);\n  color: var(--cop-accent-alt);\n}\n.copilot-welcome-recent-row-icon-svg {\n  width: 13px;\n  height: 13px;\n  stroke-width: 2;\n}\n.copilot-welcome-recent-row-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--cop-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.copilot-welcome-recent-run {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 11px;\n  background: transparent;\n  color: var(--cop-text-2);\n  border: 1px solid var(--cop-border-navy);\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;\n}\n.copilot-welcome-recent-run:hover:not(:disabled) {\n  background: var(--cop-accent-16);\n  color: var(--cop-accent-alt);\n  border-color: var(--cop-accent-42);\n}\n.copilot-welcome-recent-run:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.copilot-welcome-recent-run-icon {\n  width: 11px;\n  height: 11px;\n  stroke-width: 2.5;\n  fill: currentColor;\n}\n\n/* Empty state: no workflows yet. A single inviting CTA that opens the\n   workflows library (where recording a new workflow lives), shown in\n   place of the recent-workflows list. */\n.copilot-welcome-create {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 6px;\n  width: 100%;\n  padding: 11px 14px;\n  background: var(--cop-accent-16);\n  color: var(--cop-accent-alt);\n  border: 1px dashed var(--cop-accent-42);\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  transition: background-color 120ms ease, border-color 120ms ease, color 120ms ease;\n}\n.copilot-welcome-create:hover {\n  background: var(--cop-accent-20);\n  border-color: var(--cop-accent);\n}\n.copilot-welcome-create:focus-visible {\n  outline: 2px solid var(--cop-accent-42);\n  outline-offset: 2px;\n}\n.copilot-welcome-create-icon {\n  width: 15px;\n  height: 15px;\n  stroke-width: 2.5;\n}\n\n/* ----- Thinking bubble -----\n * Equalizer-bar animation. Five vertical brand-blue bars pulse with staggered\n * delays so the wave reads as continuous motion rather than a synchronized\n * flash. The bubble itself fades + rises in on mount so it doesn't pop into\n * existence abruptly when controller.busy flips. */\n.copilot-thinking {\n  animation: copilot-thinking-in 220ms ease-out;\n}\n@keyframes copilot-thinking-in {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.copilot-thinking-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.copilot-thinking-bars {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  height: 18px;\n  width: 36px;\n}\n.copilot-thinking-bars span {\n  display: block;\n  width: 3px;\n  border-radius: 2px;\n  background: linear-gradient(180deg, var(--cop-accent-hover), var(--cop-accent-deep));\n  transform-origin: center;\n  animation: copilot-eq 1.05s ease-in-out infinite;\n}\n.copilot-thinking-bars span:nth-child(1) { animation-delay: 0.00s; }\n.copilot-thinking-bars span:nth-child(2) { animation-delay: 0.12s; }\n.copilot-thinking-bars span:nth-child(3) { animation-delay: 0.24s; }\n.copilot-thinking-bars span:nth-child(4) { animation-delay: 0.36s; }\n.copilot-thinking-bars span:nth-child(5) { animation-delay: 0.48s; }\n@keyframes copilot-eq {\n  0%, 100% { height: 25%; opacity: 0.4; }\n  50%      { height: 100%; opacity: 1; }\n}\n.copilot-thinking-label {\n  font-family: \"IBM Plex Mono\", ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 10px;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: var(--cop-text-dim);\n}\n\n/* ----- ActionCard accent bar -----\n * Brand-blue rail along the left edge marks every tool call as a Copilot\n * action. State (running / done / error / denied / pending) is conveyed by\n * the status icon and the right/top/bottom border colour, which the state\n * badge ring class sets. The bar is a pseudo-element so it doesn't fight\n * Tailwind's border utilities. */\n.copilot-action {\n  position: relative;\n  padding-left: 10px;\n}\n.copilot-action::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: -1px;\n  bottom: -1px;\n  width: 2px;\n  background: var(--cop-accent);\n  border-radius: 2px 0 0 2px;\n}\n/* Denied actions get a dimmer rail so the card visually retreats. */\n.copilot-action--denied::before { opacity: 0.4; }\n\n/* ----- Safety confirm accent bar — same treatment, scoped via role. */\n[role=\"alertdialog\"][aria-label=\"Confirm action\"] {\n  position: relative;\n  padding-left: 12px;\n}\n[role=\"alertdialog\"][aria-label=\"Confirm action\"]::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: -1px;\n  bottom: -1px;\n  width: 2px;\n  background: var(--cop-accent-alt);\n  border-radius: 2px 0 0 2px;\n}\n\n/* ----- Screenshot thumbnail in assistant bubble -----\n * The image the model saw on this turn, rendered at the top of its bubble.\n * Button reset so the click target stays semantic but visually borderless.\n * Slight inset from the bubble's padded edges, brand-blue hairline frame,\n * and a hover lift that hints at the click-to-zoom affordance. */\n.copilot-msg-shot {\n  display: block;\n  width: 100%;\n  margin: 0 0 8px;\n  padding: 0;\n  background: var(--cop-bg-deepest);\n  border: 1px solid var(--cop-accent-28);\n  border-radius: 6px;\n  overflow: hidden;\n  cursor: zoom-in;\n  line-height: 0;\n  transition: border-color 140ms, box-shadow 140ms;\n}\n.copilot-msg-shot:hover {\n  border-color: var(--cop-accent-55);\n  box-shadow: 0 2px 10px var(--cop-accent-deep-35);\n}\n.copilot-msg-shot:focus-visible {\n  outline: 2px solid var(--cop-accent-hover);\n  outline-offset: 2px;\n}\n.copilot-msg-shot img {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 220px;\n  object-fit: cover;\n  object-position: top left;\n}\n\n/* ----- Lightbox for full-size screenshot inspection -----\n * Fixed full-viewport overlay above the panel; click backdrop or press\n * Escape to close. The image stops propagation so clicking the photo\n * itself doesn't dismiss. */\n.copilot-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 10002;\n  display: grid;\n  place-items: center;\n  padding: 32px;\n  background: var(--cop-scrim-strong);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n  animation: copilot-lightbox-in 160ms ease-out;\n  cursor: zoom-out;\n}\n@keyframes copilot-lightbox-in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n.copilot-lightbox img {\n  max-width: 100%;\n  max-height: 100%;\n  border: 1px solid var(--cop-border-14);\n  border-radius: 4px;\n  box-shadow: 0 24px 60px var(--cop-shadow-60);\n  cursor: default;\n}\n.copilot-lightbox__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: var(--cop-border-08);\n  color: var(--cop-text);\n  border: 1px solid var(--cop-border-18);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 140ms, border-color 140ms;\n}\n.copilot-lightbox__close:hover {\n  background: var(--cop-border-16);\n  border-color: var(--cop-fill-32);\n}\n\n/* ----- Reset .the-topbar list bleed -----\n * The copilot panel is mounted inside `#the-menu-items.list-horizontal\n * .aux-buttons` inside `.the-topbar`, so style.css's toolbar rules cascade\n * into every <ul>/<li> in the assistant's markdown body:\n *   .the-topbar ul {\n *     display: inline-block; overflow: hidden;\n *     text-wrap-mode: nowrap; white-space-collapse: collapse;\n *   }\n *   .the-topbar .list-horizontal li { display: inline-flex; }\n * Result: LLM bullet lists render as inline-flex pills with nowrap text\n * inside an inline-block parent — long lines bleed past the bubble cap\n * and short labels wrap letter-by-letter into a vertical column. Force\n * the lists back to a plain block layout. `!important` is justified\n * here because the toxic rules use 2-class selectors that match or beat\n * anything reasonable I can write inside the panel without spelling out\n * the topbar selectors, and the intent is a hard reset at the markdown\n * boundary regardless of where the panel mounts in future. */\n.copilot-msg-markdown ul,\n.copilot-msg-markdown ol,\n.copilot-msg-text ul,\n.copilot-msg-text ol {\n  display: block !important;\n  margin: 0.25rem 0 !important;\n  padding-left: 1.25rem !important;\n  overflow: visible !important;\n  white-space: normal !important;\n  list-style-position: outside !important;\n}\n.copilot-msg-markdown ul,\n.copilot-msg-text ul {\n  list-style-type: disc !important;\n}\n.copilot-msg-markdown ol,\n.copilot-msg-text ol {\n  list-style-type: decimal !important;\n}\n.copilot-msg-markdown li,\n.copilot-msg-text li {\n  display: list-item !important;\n  margin: 0 0 0.125rem !important;\n  padding: 0 !important;\n  line-height: 1.45 !important;\n  white-space: normal !important;\n}\n\n/* ----- Markdown body wrap-out -----\n * .copilot-root sets overflow-wrap:anywhere at the root, but the markdown\n * lib renders content through nested structures (lists, definition-like\n * blocks, inline <strong>/<em>) where the property doesn't propagate as\n * reliably — long LLM lines without breakable whitespace then escape the\n * 85% bubble cap and crash into the panel right edge. Re-apply wrap +\n * min-width:0 + max-width:100% to every descendant of the markdown body\n * so each block clamps itself to the bubble. <pre> opts back out so code\n * blocks stay scrollable horizontally (handled by tw-overflow-x-auto in\n * MarkdownText.jsx). */\n.copilot-msg-text,\n.copilot-msg-markdown {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  min-width: 0;\n  max-width: 100%;\n}\n.copilot-msg-text *,\n.copilot-msg-markdown * {\n  min-width: 0;\n  max-width: 100%;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n.copilot-msg-text pre,\n.copilot-msg-markdown pre,\n.copilot-msg-text pre *,\n.copilot-msg-markdown pre * {\n  white-space: pre;\n  word-break: normal;\n  overflow-wrap: normal;\n}\n\n/* ----- Compact display mode -----\n * Toggled from the panel header. Hides the per-turn screenshot thumbnail\n * and the action cards, leaving only the model's prose. Safety-confirm\n * prompts ([role=\"alertdialog\"]) stay visible because they require user\n * interaction; the user toggled compact for noise reduction, not to\n * disable safety. */\n.copilot-panel--compact .copilot-msg-shot,\n.copilot-panel--compact .copilot-action {\n  display: none !important;\n}\n\n/* Rare full-page error if controller.start() fails during construction. */\n.copilot-start-error {\n  position: fixed;\n  top: 80px;\n  right: 16px;\n  background: #dc2626;\n  /* Hardcoded, not themed: the background is a fixed #dc2626, while --cop-text\n   * flips to near-black in the light theme — dark-on-red is unreadable. */\n  color: #fff;\n  /* The right side reserves room for the dismiss button, which is positioned\n   * over the padding. It has to be part of this shorthand rather than a\n   * padding-right of its own — a later shorthand would silently reset it. */\n  padding: 8px 30px 8px 12px;\n  border-radius: 8px;\n  font-size: 13px;\n  z-index: 10001;\n  box-shadow: 0 8px 20px var(--cop-shadow-35);\n}\n\n/* Dismiss control. Both toasts also time themselves out (CopilotButton's\n * ERROR_TOAST_MS / SETUP_TOAST_MS), but neither used to clear at all, so this\n * is the immediate way out — it sits over the toast's right padding rather\n * than in flow, so it doesn't reflow the message or the link beside it. */\n.copilot-start-error__dismiss {\n  position: absolute;\n  top: 4px;\n  right: 6px;\n  padding: 0 4px;\n  border: 0;\n  background: none;\n  color: #fff;\n  font-size: 15px;\n  line-height: 1.2;\n  cursor: pointer;\n  opacity: 0.8;\n}\n\n.copilot-start-error__dismiss:hover,\n.copilot-start-error__dismiss:focus-visible {\n  opacity: 1;\n}\n\n/* \"Set it up\" link in the setup-required toast. White on #dc2626 is ~4.9:1,\n * which passes AA for body text. Underlined because colour alone is not a\n * sufficient affordance on an already-coloured surface (and fails WCAG\n * 1.4.1) — the link matches the toast text, so nothing else distinguishes it. */\n.copilot-start-error a {\n  color: #fff;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.copilot-start-error a:hover,\n.copilot-start-error a:focus-visible {\n  text-decoration-thickness: 2px;\n}\n\n/* Plan-progress strip — lives inside .copilot-composer-layer ABOVE the\n * Composer, so it pairs visually with the input. Auto-collapses to a single\n * line once `current_step` reaches N/N; manual toggle in either direction\n * via the header chevron / collapsed-bar click. */\n.copilot-plan-progress {\n  flex-shrink: 0;\n  padding: 8px 12px 10px;\n  border: 1px solid var(--cop-border-10);\n  border-radius: 12px;\n  background: var(--cop-bg-15);\n  box-shadow: 0 4px 12px var(--cop-shadow-20);\n  font-size: 12px;\n  line-height: 1.35;\n  max-height: 28vh;\n  overflow-y: auto;\n}\n.copilot-plan-progress__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n  font-weight: 600;\n  color: var(--cop-fill-82);\n  letter-spacing: 0.01em;\n}\n.copilot-plan-progress__header-text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.copilot-plan-progress__toggle {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--cop-fill-70);\n  cursor: pointer;\n}\n.copilot-plan-progress__toggle:hover {\n  background: var(--cop-border-08);\n  color: var(--cop-fill-95);\n}\n.copilot-plan-progress__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.copilot-plan-progress__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 2px 0;\n  color: var(--cop-fill-74);\n}\n.copilot-plan-progress__item--done {\n  color: var(--cop-fill-42);\n  text-decoration: line-through;\n}\n.copilot-plan-progress__item--active {\n  color: var(--cop-fill-95);\n  font-weight: 500;\n}\n.copilot-plan-progress__text {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n/* Collapsed mode: outer flex row hosting an \"expand\" button (the left\n * portion of the bar) and a dismiss button. The outer is no longer a\n * <button> so the dismiss <button> can be a sibling instead of an\n * invalid nested-button. */\n.copilot-plan-progress--collapsed {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  width: 100%;\n  padding: 0;\n  max-height: none;\n  font-size: 12px;\n}\n.copilot-plan-progress__expand {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 8px 8px 8px 12px;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n  color: inherit;\n}\n.copilot-plan-progress__expand:hover {\n  background: var(--cop-border-04);\n}\n.copilot-plan-progress__expand:focus-visible {\n  outline: 2px solid var(--cop-fill-35);\n  outline-offset: -2px;\n}\n.copilot-plan-progress__summary {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--cop-fill-86);\n}\n\n/* Dismiss (X) button — sibling of expand in collapsed mode, sibling of\n * the chevron toggle inside the header in expanded mode. */\n.copilot-plan-progress__header-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.copilot-plan-progress__dismiss {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--cop-fill-65);\n  cursor: pointer;\n}\n.copilot-plan-progress__dismiss:hover {\n  background: var(--cop-border-10);\n  color: var(--cop-fill-95);\n}\n.copilot-plan-progress__dismiss:focus-visible {\n  outline: 2px solid var(--cop-fill-35);\n  outline-offset: 1px;\n}\n.copilot-plan-progress--collapsed .copilot-plan-progress__dismiss {\n  margin: 6px 10px 6px 0;\n}\n\n/* Done tint — applied while collapsed so the receipt reads as success. */\n.copilot-plan-progress--done {\n  border-color: hsl(152 60% 40% / 0.35);\n  background: hsl(152 30% 12%);\n}\n.copilot-plan-progress--done .copilot-plan-progress__expand:hover {\n  background: hsl(152 30% 14%);\n}\n.copilot-plan-progress--done .copilot-plan-progress__summary {\n  color: hsl(152 65% 75%);\n}\n.copilot-plan-progress--done .copilot-plan-progress__dismiss {\n  color: hsl(152 50% 70%);\n}\n\n/* ----- Permission card (Tier 1.c § 4.4) -----\n * Inline confirmation surface rendered above the composer layer while\n * controller.pendingPermissionCard is non-null. Brand-blue accent so the\n * card reads as an active prompt; sticky checkbox is intentionally per-card\n * (its state lives in component-local React state) — the persistent\n * \"remembered\" flag only flips when Allow is chosen WITH the checkbox\n * ticked. */\n.copilot-permission-card {\n  margin: 8px 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--cop-accent-42);\n  border-radius: 10px;\n  background: var(--cop-surface-16-96);\n  color: var(--cop-text-1);\n  box-shadow: 0 4px 14px var(--cop-shadow-28);\n  animation: copilot-thinking-in 220ms ease-out;\n}\n.copilot-permission-card__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-size: 13px;\n  margin-bottom: 6px;\n  color: var(--cop-accent-bright);\n}\n.copilot-permission-card__body {\n  font-size: 12.5px;\n  color: var(--cop-text-muted);\n  margin-bottom: 10px;\n}\n.copilot-permission-card__body em {\n  font-style: italic;\n  color: var(--cop-text-1);\n}\n.copilot-permission-card__sticky {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  color: var(--cop-text-muted-70);\n  margin-bottom: 10px;\n  cursor: pointer;\n  user-select: none;\n}\n.copilot-permission-card__sticky input {\n  margin: 0;\n  cursor: pointer;\n}\n.copilot-permission-card__buttons {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n.copilot-permission-card__btn {\n  appearance: none;\n  font: inherit;\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid var(--cop-border-14);\n  background: var(--cop-surface-2);\n  color: var(--cop-text-1);\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n}\n.copilot-permission-card__btn:hover {\n  background: var(--cop-surface-3);\n}\n.copilot-permission-card__btn--primary {\n  background: var(--cop-accent);\n  border-color: var(--cop-accent);\n  color: var(--cop-on-accent);\n}\n.copilot-permission-card__btn--primary:hover {\n  background: var(--cop-accent-hover);\n  border-color: var(--cop-accent-hover);\n}\n\n/* ----- Guide-step advance chip (Tier 1.c § 4.5) -----\n * Renders above the composer layer while controller.guideStepPending is\n * true. Mirrors PermissionCard's brand-blue/dark-theme palette so the two\n * surfaces feel like one family. */\n.copilot-guide-advance {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  margin: 8px 12px;\n  padding: 8px 14px;\n  border: 1px solid var(--cop-accent-42);\n  border-radius: 10px;\n  background: var(--cop-surface-16-96);\n  box-shadow: 0 4px 14px var(--cop-shadow-28);\n  animation: copilot-thinking-in 220ms ease-out;\n}\n.copilot-guide-advance__btn {\n  appearance: none;\n  font: inherit;\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid var(--cop-border-14);\n  background: var(--cop-surface-2);\n  color: var(--cop-text-1);\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n  /* Equal-width buttons so the two-button row reads as a tidy centered\n   * pair instead of two random-width pills. */\n  flex: 1 1 0;\n  max-width: 220px;\n  text-align: center;\n}\n.copilot-guide-advance__btn:hover {\n  background: var(--cop-surface-3);\n}\n.copilot-guide-advance__btn--primary {\n  background: var(--cop-accent);\n  border-color: var(--cop-accent);\n  color: var(--cop-on-accent);\n}\n.copilot-guide-advance__btn--primary:hover {\n  background: var(--cop-accent-hover);\n  border-color: var(--cop-accent-hover);\n}\n\n/* ─── System breadcrumb pills ───\n * Lifted from kyoto-client-side-only-prototype-v2.js § cua-perm-breadcrumb.\n * \"✓\" leading glyph → granted (green); \"✕\" → denied (purple). Renders as a\n * compact inline pill rather than a full muted card so the eye doesn't\n * mistake it for a model reply. */\n.copilot-breadcrumb {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  margin: 4px 0;\n  border-radius: 999px;\n  font-size: 11px;\n  line-height: 1.4;\n  font-weight: 500;\n}\n.copilot-breadcrumb--granted {\n  background: rgba(74, 222, 128, 0.10);\n  border: 1px solid rgba(74, 222, 128, 0.28);\n  color: #6ee7a4;\n}\n.copilot-breadcrumb--denied {\n  background: rgba(168, 85, 247, 0.10);\n  border: 1px solid rgba(168, 85, 247, 0.28);\n  color: #c4b5fd;\n}\n\n/* ─── Copy-to-clipboard button on fenced code blocks ───\n * Solid-color button (not Tailwind opacity modifier — the theme's HSL\n * vars don't carry an <alpha-value> placeholder, so /xx modifiers are\n * dropped). High contrast against the muted code-block background so\n * the icon is readable without hover. */\n.copilot-codeblock-copy {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 1px solid var(--cop-border-14);\n  border-radius: 6px;\n  background: var(--cop-surface-2);\n  color: var(--cop-text-1);\n  cursor: pointer;\n  transition: background 120ms ease, color 120ms ease, border-color 120ms ease;\n}\n.copilot-codeblock-copy:hover {\n  background: var(--cop-surface-4);\n  border-color: var(--cop-border-strong);\n}\n.copilot-codeblock-copy:focus-visible {\n  outline: 2px solid var(--cop-accent-60-60);\n  outline-offset: 1px;\n}\n\n/* Belt-and-suspenders: force readable text inside fenced code blocks\n * regardless of what the assistant-ui markdown primitive applies. */\n.copilot-msg-markdown pre,\n.copilot-msg-markdown pre code {\n  color: var(--cop-text-1);\n  background: var(--cop-bg-deep-alt);\n}\n\n/* ===========================================================================\n * Workflow surface (B sub-project)\n *\n * Layered on top of the generic .copilot-modal* classes. The library and\n * param modal use --wide variants because they list rows / inputs that\n * don't fit the default 320px dialog width.\n * ========================================================================= */\n\n.copilot-workflow-library,\n.copilot-workflow-modal {\n  /* Wider than the default .copilot-modal — listings and forms need room. */\n  width: min(520px, calc(100% - 32px));\n  max-height: calc(100% - 32px);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.copilot-workflow-search {\n  width: 100%;\n  box-sizing: border-box;\n  background: var(--cop-surface);\n  border: 1px solid var(--cop-border-10);\n  border-radius: 6px;\n  padding: 7px 10px;\n  color: var(--cop-text-1);\n  font-size: 12.5px;\n}\n.copilot-workflow-search:focus-visible {\n  outline: 2px solid var(--cop-accent-60-60);\n  outline-offset: 1px;\n}\n\n.copilot-workflow-list {\n  flex: 1 1 auto;\n  min-height: 80px;\n  max-height: 50vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-right: 2px;\n}\n\n.copilot-workflow-row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  background: var(--cop-surface);\n  border: 1px solid var(--cop-border-08);\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n.copilot-workflow-row-info {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n.copilot-workflow-row-actions {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n.copilot-workflow-row-name {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--cop-text);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.copilot-workflow-row-summary {\n  margin-top: 2px;\n  font-size: 12px;\n  color: var(--cop-text-muted);\n  line-height: 1.4;\n}\n.copilot-workflow-row-meta {\n  margin-top: 4px;\n  font-size: 11.5px;\n  color: var(--cop-text-dim);\n}\n\n/* Params block inside the run modal */\n.copilot-workflow-params {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 50vh;\n  overflow-y: auto;\n}\n.copilot-workflow-param {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.copilot-workflow-param-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--cop-text-2);\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n.copilot-workflow-param input {\n  background: var(--cop-surface);\n  border: 1px solid var(--cop-border-10);\n  border-radius: 6px;\n  padding: 7px 10px;\n  color: var(--cop-text-1);\n  font-size: 12.5px;\n}\n.copilot-workflow-param input[data-error=\"true\"] {\n  border-color: hsl(0 70% 55%);\n}\n.copilot-workflow-param input:focus-visible {\n  outline: 2px solid var(--cop-accent-60-60);\n  outline-offset: 1px;\n}\n.copilot-workflow-param-desc {\n  font-size: 11.5px;\n  color: var(--cop-text-muted-65);\n}\n.copilot-workflow-param-error {\n  font-size: 11.5px;\n  color: hsl(0 70% 70%);\n}\n\n/* Inline marker shown above the chat thread while a workflow run is active */\n.copilot-workflow-run-marker {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0 12px 8px;\n  padding: 8px 10px;\n  background: var(--cop-accent-12);\n  border: 1px solid var(--cop-accent-35);\n  border-radius: 6px;\n  font-size: 12px;\n  color: var(--cop-accent-tint);\n  line-height: 1.4;\n}\n\n.copilot-workflow-run-marker__text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.copilot-workflow-run-marker__close {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin: -2px -2px 0 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: var(--cop-accent-tint);\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 120ms, background 120ms;\n}\n\n.copilot-workflow-run-marker__close:hover {\n  opacity: 1;\n  background: var(--cop-accent-20);\n}\n\n/* ============================================================\n * D.3 Workflow recording UI (Tasks 11–21)\n * Pill, settings popover, drafts list, library Record CTA,\n * wizard modal (compile / review / saved stages).\n * ============================================================ */\n\n@keyframes cua-pulse {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.4; }\n}\n\n@keyframes cua-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* --- Floating recording pill (portaled to <body>) --- */\n\n.cua-pill {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 2147483000;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 11px 18px 11px 20px;\n  background: var(--cop-bg);\n  border: 1px solid var(--cop-border);\n  border-radius: 999px;\n  box-shadow: 0 10px 30px var(--cop-shadow-45);\n  color: var(--cop-gray-96);\n  font: 500 16px/1 \"IBM Plex Sans\", system-ui, sans-serif;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n\n.cua-pill:active { cursor: grabbing; }\n\n.cua-pill-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: hsl(0 75% 55%);\n  animation: cua-pulse 1.4s ease-in-out infinite;\n}\n\n.cua-pill-time {\n  min-width: 4ch;\n  font-variant-numeric: tabular-nums;\n}\n\n.cua-pill-no-mic {\n  color: var(--cop-gray-65);\n  font-size: 12px;\n}\n\n.cua-pill-bars {\n  display: inline-flex;\n  align-items: flex-end;\n  gap: 2px;\n  height: 18px;\n}\n\n.cua-pill-bar {\n  width: 3px;\n  background: hsl(140 60% 55%);\n  border-radius: 1px;\n  transition: height 80ms linear;\n}\n\n.cua-pill-stop {\n  background: hsl(0 75% 55%);\n  color: var(--cop-text-bright);\n  border: none;\n  border-radius: 999px;\n  padding: 9px 20px;\n  font: 600 15px/1 inherit;\n  cursor: pointer;\n}\n\n.cua-pill-stop:hover { filter: brightness(1.1); }\n\n.cua-pill-warning {\n  border-color: hsl(40 90% 55%);\n  background: hsl(35 30% 15%);\n  color: hsl(45 95% 80%);\n}\n\n.cua-pill-warning .cua-pill-dot { background: hsl(40 90% 55%); }\n\n/* --- Library header: Record CTA + Settings gear --- */\n\n/* Record-a-new-workflow card. Replaces the old single-line \"Record a new\n * workflow\" button — promotes the recording flow to a self-explanatory\n * panel with a narration opt-out the user sees BEFORE the browser prompts\n * for mic permission, and a prominent red CTA. */\n.cua-record-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px 16px;\n  margin-bottom: 16px;\n  background: hsl(0 60% 12% / 0.18);\n  border: 1px solid hsl(0 70% 50% / 0.32);\n  border-radius: 12px;\n}\n\n.cua-record-card-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--cop-text);\n}\n\n.cua-record-card-blurb {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--cop-text-muted-75);\n}\n\n.cua-record-card-narrate {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  padding: 9px 11px;\n  background: var(--cop-surface-2);\n  border: 1px solid var(--cop-border-navy);\n  border-radius: 8px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--cop-text);\n  cursor: pointer;\n  transition: border-color 120ms ease, background-color 120ms ease;\n}\n.cua-record-card-narrate:hover {\n  border-color: var(--cop-accent-42);\n}\n.cua-record-card-narrate input[type=\"checkbox\"] {\n  /* native checkbox kept — accent-color tints the V check without breaking\n   * keyboard semantics. Sized up so it visually balances the text block. */\n  width: 16px;\n  height: 16px;\n  margin: 2px 0 0;\n  accent-color: hsl(140 65% 45%);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.cua-record-card-narrate strong {\n  font-weight: 600;\n}\n\n.cua-record-card-muted {\n  color: var(--cop-text-muted-70);\n}\n\n.cua-record-card-hint {\n  margin: 0;\n  font-size: 12px;\n  color: var(--cop-text-muted-70);\n}\n.cua-record-card-hint strong {\n  color: var(--cop-text-muted-75);\n  font-weight: 600;\n}\n\n.cua-record-card-actions {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.cua-record-card-start {\n  flex: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  padding: 11px 16px;\n  background: hsl(0 72% 52%);\n  color: #fff;\n  border: 0;\n  border-radius: 8px;\n  font: 600 14px/1 \"IBM Plex Sans\", system-ui, sans-serif;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  box-shadow:\n    0 1px 0 hsl(0 72% 62% / 0.35) inset,\n    0 6px 14px hsl(0 72% 25% / 0.35);\n  transition: filter 120ms ease, transform 80ms ease;\n}\n.cua-record-card-start:hover:not(:disabled) {\n  filter: brightness(1.06);\n}\n.cua-record-card-start:active:not(:disabled) {\n  transform: translateY(1px);\n}\n.cua-record-card-start:disabled {\n  background: var(--cop-surface-2);\n  color: var(--cop-text-muted-70);\n  cursor: not-allowed;\n  box-shadow: none;\n}\n/* Slightly larger dot inside the big CTA so it reads at the button's scale. */\n.cua-record-card-start .cua-library-rec-dot {\n  width: 9px;\n  height: 9px;\n  background: #fff;\n  box-shadow: 0 0 0 3px hsl(0 0% 100% / 0.18);\n}\n\n.cua-library-rec-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: hsl(0 75% 55%);\n  flex-shrink: 0;\n}\n\n.cua-library-rec-warn {\n  background: hsl(40 30% 14%);\n  color: hsl(45 90% 78%);\n  border: 1px solid hsl(40 60% 30%);\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n/* --- Settings popover (gear) --- */\n\n.cua-settings {\n  position: relative;\n}\n\n.cua-settings-trigger {\n  background: var(--cop-border-06);\n  color: var(--cop-gray-90);\n  border: 1px solid var(--cop-border);\n  border-radius: 6px;\n  width: 36px;\n  height: 36px;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.cua-settings-trigger:hover { background: var(--cop-border-10); }\n\n.cua-settings-popover {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: var(--cop-bg);\n  border: 1px solid var(--cop-border);\n  border-radius: 6px;\n  padding: 10px;\n  z-index: 10;\n  min-width: 200px;\n  box-shadow: 0 6px 20px var(--cop-shadow-40b);\n}\n\n.cua-settings-h {\n  font-size: 12px;\n  color: var(--cop-gray-70);\n  margin-bottom: 6px;\n}\n\n.cua-settings-opt {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 0;\n  cursor: pointer;\n  font-size: 13px;\n  color: var(--cop-gray-92);\n}\n\n/* --- Drafts list --- */\n\n.cua-drafts {\n  margin-bottom: 14px;\n}\n\n.cua-drafts-header {\n  font-size: 13px;\n  color: var(--cop-gray-75);\n  margin-bottom: 6px;\n}\n\n.cua-drafts-banner {\n  background: hsl(40 30% 14%);\n  color: hsl(45 90% 78%);\n  border: 1px solid hsl(40 60% 30%);\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  margin-bottom: 8px;\n}\n\n.cua-drafts-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cua-drafts-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 8px 10px;\n  background: var(--cop-border-03);\n  border: 1px solid var(--cop-border-08);\n  border-radius: 6px;\n}\n\n.cua-drafts-row-thumb {\n  flex: 0 0 auto;\n  width: 48px;\n  height: 32px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: var(--cop-border-05);\n}\n.cua-drafts-row-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.cua-drafts-row-thumb-empty {\n  width: 100%;\n  height: 100%;\n  background: var(--cop-border-04);\n}\n\n.cua-drafts-row-main { flex: 1 1 auto; min-width: 0; }\n\n.cua-drafts-row-name { font-weight: 600; color: var(--cop-gray-95); font-size: 13px; }\n.cua-drafts-row-meta { font-size: 12px; color: var(--cop-gray-65); display: block; margin-top: 2px; }\n\n.cua-drafts-status {\n  display: inline-block;\n  padding: 1px 6px;\n  border-radius: 999px;\n  font-size: 11px;\n  background: var(--cop-border-08);\n  color: var(--cop-gray-90);\n}\n.cua-drafts-status-compiled { background: hsl(140 50% 25%); color: hsl(140 60% 85%); }\n.cua-drafts-status-compile_failed { background: hsl(0 50% 25%); color: hsl(0 60% 85%); }\n\n.cua-drafts-row-actions { display: flex; gap: 6px; }\n\n.cua-drafts-resume, .cua-drafts-discard {\n  background: var(--cop-border-06);\n  color: var(--cop-gray-92);\n  border: 1px solid var(--cop-border);\n  border-radius: 4px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.cua-drafts-discard { color: hsl(0 70% 75%); }\n.cua-drafts-resume:hover { background: var(--cop-border); }\n.cua-drafts-discard:hover { background: hsl(0 50% 20%); }\n\n/* --- Wizard modal (inside the panel) --- */\n\n.cua-wizard-modal {\n  position: absolute;\n  inset: 0;\n  background: var(--cop-bg-deep);\n  border: 1px solid var(--cop-border);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  z-index: 20;\n  overflow: hidden;\n}\n\n.cua-wizard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--cop-border-08);\n}\n\n.cua-wizard-title {\n  font: 600 15px/1 \"IBM Plex Sans\", system-ui, sans-serif;\n  color: var(--cop-gray-96);\n}\n\n.cua-wizard-close {\n  background: transparent;\n  color: var(--cop-gray-70);\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.cua-wizard-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  color: var(--cop-gray-92);\n  font-size: 13px;\n}\n\n/* --- Compile stage --- */\n\n.cua-compile-stage { display: flex; flex-direction: column; gap: 14px; }\n\n.cua-compile-autostop-banner {\n  background: hsl(40 30% 14%);\n  color: hsl(45 90% 78%);\n  border: 1px solid hsl(40 60% 30%);\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n}\n\n.cua-compile-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--cop-border);\n  border-top-color: var(--cop-accent-hover);\n  border-radius: 50%;\n  margin: 8px auto;\n  animation: cua-spin 0.9s linear infinite;\n}\n\n.cua-compile-phases {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n}\n\n.cua-compile-phases li.pending { color: var(--cop-gray-50); }\n.cua-compile-phases li.active  { color: var(--cop-accent-bright); font-weight: 600; }\n.cua-compile-phases li.done    { color: hsl(140 50% 75%); }\n\n.cua-compile-error {\n  background: hsl(0 50% 18%);\n  color: hsl(0 70% 88%);\n  border: 1px solid hsl(0 60% 35%);\n  border-radius: 6px;\n  padding: 10px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cua-compile-retry {\n  align-self: flex-start;\n  background: hsl(0 60% 35%);\n  color: var(--cop-text-bright);\n  border: none;\n  border-radius: 4px;\n  padding: 4px 12px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n/* --- Review form --- */\n\n.cua-review-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cua-review-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cua-review-section-title {\n  font: 600 12px/1 \"IBM Plex Sans\", system-ui, sans-serif;\n  color: var(--cop-gray-70);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.cua-review-field { display: flex; flex-direction: column; gap: 4px; }\n.cua-review-field label { font-size: 12px; color: var(--cop-gray-70); }\n.cua-review-field input,\n.cua-review-field textarea,\n.cua-review-notes,\n.cua-review-step-intent,\n.cua-review-step-uses,\n.cua-review-param-name,\n.cua-review-param-desc,\n.cua-review-prereq {\n  background: var(--cop-border-05);\n  color: var(--cop-gray-95);\n  border: 1px solid var(--cop-border);\n  border-radius: 4px;\n  padding: 6px 8px;\n  font: 400 13px/1.4 \"IBM Plex Sans\", system-ui, sans-serif;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.cua-review-field-error {\n  color: hsl(0 70% 75%);\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.cua-review-row {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.cua-review-row-remove {\n  background: transparent;\n  color: var(--cop-gray-60);\n  border: 1px solid var(--cop-border);\n  border-radius: 4px;\n  width: 24px;\n  height: 24px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.cua-review-row-add {\n  align-self: flex-start;\n  background: var(--cop-border-05);\n  color: var(--cop-accent-bright);\n  border: 1px dashed var(--cop-border-18);\n  border-radius: 4px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.cua-review-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 8px;\n  border-top: 1px solid var(--cop-border-08);\n}\n\n.cua-review-meta {\n  font-size: 12px;\n  color: var(--cop-gray-65);\n}\n\n.cua-review-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* Review/saved footer buttons use the shared .copilot-modal-btn classes\n   (including --danger) for sizing parity with the rest of the panel — the\n   former .cua-btn-primary/.cua-btn-danger rules were removed. */\n\n/* --- Saved stage --- */\n\n.cua-saved-stage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 24px 16px;\n  text-align: center;\n}\n\n.cua-check {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: hsl(140 50% 25%);\n  color: hsl(140 60% 85%);\n  display: grid;\n  place-items: center;\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.cua-saved-name {\n  font: 600 16px/1.2 \"IBM Plex Sans\", system-ui, sans-serif;\n  color: var(--cop-gray-96);\n}\n\n.cua-saved-sub {\n  font-size: 12px;\n  color: var(--cop-gray-65);\n}\n\n.cua-saved-hint {\n  font-size: 12px;\n  color: var(--cop-gray-55);\n  font-style: italic;\n  margin: 8px 0;\n}\n\n.cua-saved-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n/* ============================================================\n   Captured stage — \"review your take\" before compiling.\n   ============================================================ */\n.cua-captured-stage {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 4px 2px;\n}\n\n.cua-captured-filmstrip {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding-bottom: 4px;\n  scrollbar-width: thin;\n}\n\n.cua-captured-frame {\n  margin: 0;\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  position: relative;\n}\n\n.cua-captured-frame img {\n  width: 135px;\n  height: 83px;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid var(--cop-border);\n  background: var(--cop-gray-12);\n  display: block;\n  cursor: zoom-in;\n}\n\n/* Per-frame multi-select toggle — a custom circular check, hidden until hover\n   or when on. */\n.cua-captured-frame-sel {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  border: 1.5px solid #fff;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.45);\n  color: transparent;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.12s ease, background 0.12s ease;\n  display: grid;\n  place-items: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n.cua-captured-frame:hover .cua-captured-frame-sel,\n.cua-captured-frame-sel.is-on,\n.cua-captured-frame-sel:focus-visible { opacity: 1; }\n.cua-captured-frame-sel.is-on {\n  background: var(--cop-accent, hsl(220 90% 66%));\n  border-color: var(--cop-accent, hsl(220 90% 66%));\n  color: #fff;\n}\n.cua-captured-frame--selected img {\n  outline: 2px solid var(--cop-accent, hsl(220 90% 66%));\n  outline-offset: -2px;\n}\n\n/* Per-frame quick-delete ✕ (top-right) — instant single-frame delete. */\n.cua-captured-frame-del {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 20px;\n  height: 20px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.12s ease, background 0.12s ease;\n  display: grid;\n  place-items: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n.cua-captured-frame:hover .cua-captured-frame-del,\n.cua-captured-frame-del:focus-visible { opacity: 1; }\n.cua-captured-frame-del:hover { background: hsl(0 70% 45%); }\n\n.cua-captured-selbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n  color: var(--cop-gray-96);\n}\n.cua-captured-selbar .copilot-modal-btn { margin-left: auto; }\n\n/* Zoom preview — a modest centred enlargement, not a full-page lightbox. */\n.cua-captured-zoom {\n  position: fixed;\n  inset: 0;\n  z-index: 10060;            /* above the sheet (10050) */\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px;\n  cursor: zoom-out;\n}\n.cua-captured-zoom img {\n  max-width: min(1100px, 90vw);\n  max-height: 88vh;\n  border-radius: 8px;\n  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.5);\n  cursor: default;\n}\n\n.cua-captured-transcribe {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.cua-captured-transcribe-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--cop-accent, hsl(220 90% 66%));\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.cua-captured-transcribe-link:disabled {\n  color: var(--cop-gray-55);\n  cursor: default;\n  text-decoration: none;\n}\n.cua-captured-optional-hint {\n  font-size: 11px;\n  color: var(--cop-gray-55);\n}\n\n.cua-captured-frame figcaption {\n  font-size: 10px;\n  color: var(--cop-gray-55);\n  font-variant-numeric: tabular-nums;\n}\n\n.cua-captured-summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  color: var(--cop-gray-96);\n}\n\n.cua-captured-sep { color: var(--cop-gray-55); }\n\n.cua-captured-narration { min-height: 24px; }\n\n.cua-captured-hint {\n  font-size: 12px;\n  color: var(--cop-gray-65);\n  font-style: italic;\n}\n\n.cua-captured-transcript {\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid var(--cop-border);\n  border-radius: 8px;\n  padding: 10px 12px;\n  background: var(--cop-gray-12);\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cua-captured-transcript-empty {\n  font-size: 12px;\n  color: var(--cop-gray-55);\n  font-style: italic;\n}\n\n.cua-captured-transcript-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.cua-captured-transcript-t {\n  flex-shrink: 0;\n  color: var(--cop-gray-55);\n  font-variant-numeric: tabular-nums;\n}\n\n.cua-captured-transcript-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  background: var(--cop-gray-16, var(--cop-gray-12));\n  border: 1px solid var(--cop-border);\n  border-radius: 5px;\n  color: var(--cop-gray-96);\n  font-size: 12px;\n  padding: 3px 7px;\n}\n.cua-captured-transcript-input:focus {\n  outline: none;\n  border-color: var(--cop-accent, hsl(220 90% 66%));\n}\n\n.cua-captured-transcript-del {\n  flex: 0 0 auto;\n  background: none;\n  border: none;\n  color: var(--cop-gray-55);\n  font-size: 11px;\n  cursor: pointer;\n  padding: 2px 4px;\n}\n.cua-captured-transcript-del:hover { color: hsl(0 70% 60%); }\n\n.cua-captured-error {\n  font-size: 12px;\n  color: hsl(0 70% 70%);\n}\n\n.cua-captured-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n/* ============================================================\n   Standalone modal \"sheet\" — portaled to <body> so it escapes the\n   floating panel's transform/opacity (which otherwise trap a\n   position:fixed backdrop inside the ~400px panel). Shared by the\n   workflow library, the run-params prompt, and the record → review →\n   save wizard. Themed via --cop-* tokens, so it follows light/dark.\n   ============================================================ */\n.copilot-sheet-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;                 /* above the floating panel (z 10000) */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  background: var(--cop-scrim);\n  backdrop-filter: blur(3px) saturate(115%);\n  -webkit-backdrop-filter: blur(3px) saturate(115%);\n  animation: copilot-sheet-fade 140ms ease-out;\n}\n@keyframes copilot-sheet-fade { from { opacity: 0; } to { opacity: 1; } }\n\n.copilot-sheet {\n  display: flex;\n  flex-direction: column;\n  width: clamp(320px, 92vw, 680px);\n  max-height: min(88vh, 860px);\n  background: linear-gradient(180deg, var(--cop-surface-14-94) 0%, var(--cop-bg-deep-glass) 100%);\n  color: var(--cop-text-1);\n  border: 1px solid var(--cop-border-14);\n  border-radius: 16px;\n  box-shadow:\n    0 24px 64px var(--cop-shadow-45),\n    0 2px 10px var(--cop-shadow-28),\n    inset 0 1px 0 var(--cop-border-06);\n  overflow: hidden;\n  animation: copilot-sheet-rise 200ms cubic-bezier(.2,.7,.2,1);\n}\n.copilot-sheet--sm { width: clamp(300px, 90vw, 460px); }\n.copilot-sheet--lg { width: clamp(320px, 94vw, 820px); }\n@keyframes copilot-sheet-rise {\n  from { opacity: 0; transform: translateY(10px) scale(.985); }\n  to   { opacity: 1; transform: none; }\n}\n\n.copilot-sheet-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 22px;\n  border-bottom: 1px solid var(--cop-border-08);\n  background: var(--cop-surface-18-80);\n}\n.copilot-sheet-title {\n  font: 600 16px/1.25 \"IBM Plex Sans\", system-ui, sans-serif;\n  color: var(--cop-text);\n  letter-spacing: -0.01em;\n}\n.copilot-sheet-close {\n  flex: 0 0 auto;\n  background: transparent;\n  color: var(--cop-text-dim);\n  border: 1px solid transparent;\n  border-radius: 8px;\n  width: 30px;\n  height: 30px;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 120ms, color 120ms;\n}\n.copilot-sheet-close:hover { background: var(--cop-border-08); color: var(--cop-text); }\n\n.copilot-sheet-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 22px;\n}\n\n.copilot-sheet-footer {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 22px;\n  border-top: 1px solid var(--cop-border-08);\n  background: var(--cop-surface-16-96);\n}\n.copilot-sheet-footer--split { justify-content: space-between; }\n\n/* Review/param/step rows: let the inputs shrink so the remove button is\n   never clipped (the row is flex; without min-width:0 the inputs refuse to\n   shrink below content width and push the ✕ off the edge). */\n.cua-review-row > input,\n.cua-review-row > .cua-review-prereq,\n.cua-review-param-name,\n.cua-review-param-desc,\n.cua-review-step-intent {\n  flex: 1 1 0;\n  min-width: 0;\n}\n.cua-review-param-name { flex: 0 1 34%; }\n.cua-review-step-uses { flex: 0 1 38%; min-width: 0; }\n.cua-review-row-remove { flex: 0 0 auto; }\n\n.cua-review-step-drag {\n  flex: 0 0 auto;\n  cursor: grab;\n  user-select: none;\n  color: var(--cop-gray-55);\n  font-size: 14px;\n  line-height: 1;\n  padding: 0 2px;\n  align-self: center;\n}\n.cua-review-step-drag:active { cursor: grabbing; }\n\n/* Roomier rhythm now that the sheet has space to breathe. */\n.copilot-sheet-body .cua-review-form { gap: 18px; }\n.copilot-sheet-body .cua-review-section { gap: 8px; }\n\n/* Inside the sheet the body is the single scroll container — drop the\n   modal-era width caps and the list's own scroll so they don't double up. */\n.copilot-sheet-body .copilot-workflow-library {\n  width: auto;\n  max-height: none;\n  gap: 14px;\n}\n.copilot-sheet-body .copilot-workflow-list {\n  max-height: none;\n  overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
